import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Search,
  DeleteForever,
} from "@mui/icons-material";
import "devextreme/data/odata/store";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Card, Col, Container, Dropdown, Form, Modal, Pagination, Row, Table } from "react-bootstrap";
import * as yup from "yup";

import API, { AxiosInstance } from "../../api/api";
import { parsedUser } from "../../utils/GetCurrentUser";
import { useLocation, useParams } from "react-router-dom";
import { TextBox, SelectBox, DateBox } from "devextreme-react";
import FieldSelector from "../../components/customComponents/FieldSelector";
import { useFormik } from "formik";
import Sha256 from "../../utils/sha256";
import logoSignos from "../../assets/SignosFrameworkLogo.png";

import { useToast } from "../../contexts/toast";
import { useApiResponseHandler } from "../../hooks/useApiResponseHandler";
import yupTypeValidator from "../../utils/YupTypeValidator";
import { exportToPDF as GeneratePDF } from '../../utils/export-to-pdf';
import { exportToExcel as GenerateXLS } from '../../utils/export-to-excel';
import { CustomBreadcrumbs as Breadcrumbs } from "../../components";
import CustomModal from "../../components/CustomModal/CustomModal";
import useFavorite from "../../hooks/useFavorite";
import moment from "moment";
import "../../index.css";
import "../../styles/stickyTable.css";

// Componente personalizado para el botón de cerrar modal
const CustomCloseButton = ({ onClose }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      style={{
        border: "1px solid #b0b0b0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s ease",
        backgroundColor: isHovered ? "#ff4136" : "",
        cursor: "pointer",
      }}
      className="btn"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClose}
      aria-label="Close"
    >
      <i 
        style={{ 
          fontSize: "20px", 
          color: isHovered ? "#ffffff" : "#b0b0b0",
          transition: "color 0.2s ease"
        }} 
        className="fa-solid fa-xmark"
      ></i>
    </button>
  );
};

export default function ProcessSimpleV1() {  
  // PROPERTIES
  const user = parsedUser();
  const { pathname } = useLocation();
  const params = useParams();
  const { idModule } = useParams();
  const toast = useToast();
  const { handleApiResponse, ErrorModal } = useApiResponseHandler();

  const [recordCount, setRecordCount] = useState(10); // 10 registros de empleados
  const [totalPages, setTotalPages] = useState(1);
  const [generalError, setGeneralError] = useState(null);
  const [open, setOpen] = useState(false);
  const [actionMode, setActionMode] = useState(null);//I=Insert, U= Update = C= Consultar, D= Delete
  const [loading, setLoading] = useState(false);
  const [loadingFilters, setLoadingFilters] = useState(true); // Estado para controlar carga de filtros
  // const [isPinned, setIsPinned] = useState(false);
  const [selectedMotivo, setSelectedMotivo] = useState(null);
  const [motivosOptions, setMotivosOptions] = useState([]);
  const [loadingMotivos, setLoadingMotivos] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [isSearching, setIsSearching] = useState(true);
  const checkAudit = localStorage.getItem('AuditInformation')
  const [showTable, setShowTable] = useState(false); // Ocultar tabla hasta que se consulte

  const initialModel = {
    section: {},
    data: {
      Columns: [],
      Rows: [],
      Summary: [],
      Alignment: [],
    },
  }
  const [section, setSection] = useState({ FormTitle: "", FormPath: "", FormIcon: "" });
  const [fields, setFields] = useState([])
  const [filters, setFilters] = useState([]) // Filtros dinámicos del Model
  const [model, setModel] = useState(initialModel);
  const [search, setSearch] = useState(""); // Búsqueda general (string simple)
  const [columnFilters, setColumnFilters] = useState({}); // Filtros por columna (objeto)
  
  // Estados para los filtros de Código y Nombre
  // const [filtroCodigo, setFiltroCodigo] = useState('');
  // const [filtroNombre, setFiltroNombre] = useState('');
  const [dynamicFilters, setDynamicFilters] = useState([]); // Metadata de filtros del backend
  const [filterValues, setFilterValues] = useState({}); // Valores de los filtros
  const [openFilterColumn, setOpenFilterColumn] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [RecordsQuantity, setRecordsQuantity] = useState(10);
  const allowedPageSizes = [{ value: 10, text: 10 }, { value: 20, text: 20 }, { value: 50, text: 50 }, { value: 100, text: 100 }, { value: 0, text: "Todos" }];
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);
  const { isPinned, UpdateFavorites, checkIfPinned } = useFavorite()
  const selectedItemRef = useRef(null);
  const [sortBy, setSortBy] = useState('Id')
  const [sortByOrder, setSortByOrder] = useState('DESC')
  
  // Estados para la tabla de detalle dentro del modal
  const [detailItems, setDetailItems] = useState([]);
  const [newDetailItem, setNewDetailItem] = useState({ campo1: '', campo2: '' });
  const [plazasHeaders, setPlazasHeaders] = useState([]);
  const [comentarioAsignacion, setComentarioAsignacion] = useState('');
  const [fechaAsignacion, setFechaAsignacion] = useState(''); // Estado para la fecha de asignación

  const [selectedPlaza, setSelectedPlaza] = useState(null);
  const [selectedPlazaIndex, setSelectedPlazaIndex] = useState(null);
  
  // Ref para el textarea del comentario (para hacer scroll)
  const comentarioRef = useRef(null);
  const stickyHeaderRef = useRef(null);
  const [stickyHeaderHeight, setStickyHeaderHeight] = useState(0);
  
  // Estados para los campos de asignación
  const [selectedCodigo, setSelectedCodigo] = useState('');
  const [selectedNombre, setSelectedNombre] = useState('');
  const [selectedGenero, setSelectedGenero] = useState('');
  const [selectedFechaNac, setSelectedFechaNac] = useState('');
  const [selectedEdad, setSelectedEdad] = useState('');
  const [selectedTipo, setSelectedTipo] = useState('');
  const [selectedCategoria, setSelectedCategoria] = useState('');
  const [selectedDepartamento, setSelectedDepartamento] = useState('');
  const [selectedNivelPuesto, setSelectedNivelPuesto] = useState('');
  const [selectedCargo, setSelectedCargo] = useState('');
  const [selectedTipoVivienda, setSelectedTipoVivienda] = useState('');
  
  // Funciones para manejar la tabla de detalle
  const addDetailItem = () => {
    if (newDetailItem.campo1 && newDetailItem.campo2) {
      setDetailItems([...detailItems, { ...newDetailItem, id: Date.now() }]);
      setNewDetailItem({ campo1: '', campo2: '' });
    }
  };
  
  const removeDetailItem = (id) => {
    setDetailItems(detailItems.filter(item => item.id !== id));
  };
  
  // Filter helper functions
  const updateColumnFilter = (fieldName, value) => {
    setColumnFilters(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  const clearAllFilters = async () => {
    setSearch("");
    setColumnFilters({});
    setOpenFilterColumn(null);
    setShowTable(false); // Ocultar tabla al limpiar filtros
    setCurrentPage(1); // Resetear a la primera página
    setRecordsQuantity(10); // Resetear cantidad de registros al valor por defecto
    
    // Resetear filtros dinámicos a sus valores por defecto
    if (dynamicFilters && dynamicFilters.length > 0) {
      const defaults = initializeFilterDefaults(dynamicFilters);
      setFilterValues(defaults);
    }
    
    // Limpiar filtros de Código y Nombre
    // setFiltroCodigo('');
    // setFiltroNombre('');
    // Restaurar todos los datos originales
    setModel({
      ...model,
      data: {
        ...model.data,
        Rows: initialModel.data.Rows
      }
    });
    setRecordCount(initialModel.data.Rows.length);
  };

  const toggleFilterDropdown = (fieldName) => {
    setOpenFilterColumn(openFilterColumn === fieldName ? null : fieldName);
  };

  const applyColumnFilter = async () => {
    setOpenFilterColumn(null);
    await bindDataRemote();
    await bindDataCountRemote();
  };

  const clearSingleColumnFilter = async (fieldName) => {
    setColumnFilters(prev => {
      const newFilters = { ...prev };
      delete newFilters[fieldName];
      return newFilters;
    });
    setTimeout(async () => {
      await bindDataRemote();
      await bindDataCountRemote();
    }, 100);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openFilterColumn && !event.target.closest('.position-relative')) {
        setOpenFilterColumn(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openFilterColumn]);
  
  // END PROPERTIES



  //METHODS
  ///BRING THE DATA FROM THE SERVER FOR MODEL AND RECORDS
  const bindDataRemote = useCallback(async (cleanFilter) => {

    // First start loading the model
    setLoading(true);

    //First load records

    try {
      let query = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      
      // Filtrar solo los campos con valores no vacíos
      const activeFilters = Object.keys(columnFilters).reduce((acc, key) => {
        const value = columnFilters[key];
        if (value !== null && value !== undefined && value !== "") {
          acc[key] = value;
        }
        return acc;
      }, {});

      // Filtros por columna tienen prioridad sobre búsqueda general
      if (Object.keys(activeFilters).length > 0 && cleanFilter == null) {
        query += "&Search=" + encodeURIComponent(JSON.stringify(activeFilters));
      } else if (search.length > 0 && cleanFilter == null) {
        // Búsqueda general solo si no hay filtros de columna
        query += "&Search=" + search;
      }
      
      // Garantizar que RecordsQuantity sea un número
      const quantityNumber = Number(RecordsQuantity);
      let quantity = quantityNumber === 0 ? recordCount : quantityNumber;
      
      query += `&PageNumber=${currentPage}&Quantity=${quantity}&SortBy=${sortBy}&SortType=${sortByOrder}`;
      
      console.log("🔍 QUERY Records:", query);
      let prefix = idModule ? "CRUDDynamic" : "CRUD";
      let request = await API.getAction(`api/${prefix}/ReportRecords`, query);
      
      console.log("🔍 RAW Response:", request.data);
      
      // Para reportes, la respuesta puede venir directamente como array
      let dataFromAPI = [];
      let summaryFromAPI = [];
      let alignmentFromAPI = [];
      
      if (Array.isArray(request.data) && request.data.length > 0) {
        // Si viene directamente como array de objetos
        if (request.data[0].JSONData) {
          // Caso 1: Viene con JSONData wrapper
          let results = request.data[0];
          let parsedResults = JSON.parse(results.JSONData);
          console.log("📊 Parsed Results:", parsedResults);
          
          // Verificar si viene en el formato nuevo con ReportData
          if (parsedResults.ReportData && parsedResults.ReportData.Data) {
            dataFromAPI = parsedResults.ReportData.Data;
            summaryFromAPI = parsedResults.ReportData.Summary || [];
            alignmentFromAPI = parsedResults.ReportData.Alignment || [];
            console.log("📊 Caso 1A - Con ReportData.Data:", dataFromAPI);
            console.log("📊 Summary:", summaryFromAPI);
            console.log("📊 Alignment:", alignmentFromAPI);
          } else if (Array.isArray(parsedResults) && parsedResults[0]) {
            // Formato antiguo
            let recordResult = parsedResults[0].JSONData || [];
            dataFromAPI = recordResult[0] ? (recordResult[0].JSONConfig ? recordResult[0].JSONData : recordResult) : [];
            console.log("📊 Caso 1B - Formato antiguo con array:", dataFromAPI);
          } else if (parsedResults.JSONData) {
            dataFromAPI = parsedResults.JSONData;
            console.log("📊 Caso 1C - Con JSONData directo:", dataFromAPI);
          }
        } else {
          // Caso 2: Viene directamente como array (reportes)
          dataFromAPI = request.data;
          console.log("📊 Caso 2 - Array directo (reportes):", dataFromAPI);
        }
      }
      
      console.log("✅ Final dataFromAPI:", dataFromAPI);
      console.log("✅ Final summaryFromAPI:", summaryFromAPI);
      console.log("✅ Final alignmentFromAPI:", alignmentFromAPI);


      //TODO: | Use JSONConfig to show specific fields
      let gridData = null;
      let gridColumns = dataFromAPI && dataFromAPI.length > 0 ? Object.keys(dataFromAPI[0]).filter(x => !x.startsWith("Id")) : null;

      //! If grid data stays null, we use the data from the API

      let titles = ['Audit Information', 'Added by', 'Date Added', 'Modified by', 'Last Modified']

      /*setModel({
        ...model,

        data: {
          ...model.data,
          Columns: gridColumns,
          Rows: gridData || dataFromAPI,
        },
      }); */
      //debugger;
      setModel({
        ...model,
        
        data: {
          ...model.data,
          Columns: gridColumns,
          Rows: dataFromAPI,
          Summary: summaryFromAPI,
          Alignment: alignmentFromAPI,
        },
      });



    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [currentPage, search, columnFilters, sortBy, sortByOrder, RecordsQuantity, params.id, idModule]);


  // useEffect(() => {
  //   setTableHeader([])
  //   setSelectedItem(null);
  //   setSelectedItemIndex(null);
  //   bindDataRemote();
  //   bindDataCountRemote();
  // }, [params.id, idModule, bindDataRemote])

  // Limpiar selección cuando cambia la página
  useEffect(() => {
    setSelectedItem(null);
    setSelectedItemIndex(null);
  }, [currentPage])

  const bindDataCountRemote = async (cleanFilter) => {

    // First start loading the model
    //setLoading(true);

    //First load records

    try {
      let query = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      
      // Filtrar solo los campos con valores no vacíos
      const activeFilters = Object.keys(columnFilters).reduce((acc, key) => {
        const value = columnFilters[key];
        if (value !== null && value !== undefined && value !== "") {
          acc[key] = value;
        }
        return acc;
      }, {});

      // Filtros por columna tienen prioridad sobre búsqueda general
      if (Object.keys(activeFilters).length > 0 && cleanFilter == null) {
        query += "&Search=" + encodeURIComponent(JSON.stringify(activeFilters));
      } else if (search.length > 0 && cleanFilter == null) {
        // Búsqueda general solo si no hay filtros de columna
        query += "&Search=" + search;
      }
      
      console.log("🔍 QUERY RecordsCount:", query);
      let prefix = idModule ? "CRUDDynamic" : "CRUD";
      let request = await API.getAction(`api/${prefix}/RecordsCount`, query);

      console.log("🔍 RAW RecordsCount Response:", request.data);
      
      let count = 0;
      if (Array.isArray(request.data) && request.data.length > 0) {
        if (request.data[0].JSONData) {
          // Caso con JSONData wrapper
          let results = request.data[0];
          let parsedResults = typeof results.JSONData === 'string' 
            ? JSON.parse(results.JSONData) 
            : results.JSONData;
          console.log("📊 Parsed RecordsCount Results:", parsedResults);
          
          // Verificar el formato nuevo JSONData.Count[0].Count
          if (parsedResults.JSONData?.Count && Array.isArray(parsedResults.JSONData.Count) && parsedResults.JSONData.Count[0]?.Count !== undefined) {
            count = parsedResults.JSONData.Count[0].Count;
            console.log("📊 RecordsCount - Nuevo formato JSONData.Count[0].Count:", count);
          }
          // Formato alternativo: Count[0].Count directo
          else if (Array.isArray(parsedResults.Count) && parsedResults.Count[0]?.Count !== undefined) {
            count = parsedResults.Count[0].Count;
            console.log("📊 RecordsCount - Formato Count[0].Count:", count);
          }
          // Verificar si viene en el formato con ReportData
          else if (parsedResults.ReportData?.Count !== undefined) {
            count = parsedResults.ReportData.Count;
            console.log("📊 RecordsCount - Con ReportData.Count:", count);
          } else if (parsedResults[0]?.JSONData?.Count !== undefined) {
            count = parsedResults[0].JSONData.Count;
            console.log("📊 RecordsCount - Formato antiguo con Count:", count);
          } else if (parsedResults.Count !== undefined) {
            count = parsedResults.Count;
            console.log("📊 RecordsCount - Count directo en parsedResults:", count);
          } else {
            count = request.data[0].Count || 0;
            console.log("📊 RecordsCount - Count en data[0]:", count);
          }
        } else {
          // Caso directo
          count = request.data[0].Count || 0;
          console.log("📊 RecordsCount - Directo:", count);
        }
      }
      
      setRecordCount(count);
      console.log("✅ Final Record Count:", count)


    } catch (error) {
      console.error(error);
    } finally {
      // setLoading(false);
    }
  };
  
  // Added by Victor: Agrega funcion para cargar los motivos del select en el modal
  const loadMotivosOptions = async () => {
    try {
      setLoadingMotivos(true);
      
      // Hacer la petición sin el interceptor automático
      const response = await AxiosInstance.get(
        `api/OcupacionProcesos/GetSelectData?FKField=IdMotivoEntrada&Token=${user.Token}`,
        { 
          transformResponse: [(data) => {
            // No transformar la respuesta, devolverla como string
            return data;
          }]
        }
      );
      
      console.log("📋 Response raw motivos:", response.data);
      
      let options = [];
      
      // Parsear la respuesta: primero el objeto que contiene JSONData
      const parsedResponse = JSON.parse(response.data);
      console.log("📋 Response parseado:", parsedResponse);
      
      // Verificar si tiene la estructura esperada [0].JSONData (como CheckOut)
      if (parsedResponse && parsedResponse[0] && parsedResponse[0].JSONData) {
        console.log("📋 JSONData encontrado:", parsedResponse[0].JSONData);
        
        // Parsear JSONData que contiene el array de motivos
        options = JSON.parse(parsedResponse[0].JSONData);
        console.log("✅ Motivos parseados correctamente!");
      } else if (parsedResponse && parsedResponse.JSONData) {
        // Alternativa: si viene como objeto directo {JSONData: ...}
        console.log("📋 JSONData encontrado (formato objeto):", parsedResponse.JSONData);
        options = JSON.parse(parsedResponse.JSONData);
        console.log("✅ Motivos parseados correctamente (formato objeto)!");
      } else if (Array.isArray(parsedResponse)) {
        // Si ya es un array directo
        options = parsedResponse;
      }
      
      console.log("✅ Total Motivos cargados:", options.length);
      console.log("✅ Motivos completos:", options);
      setMotivosOptions(options);
      
    } catch (error) {
      console.error("❌ Error al cargar motivos:", error);
      console.error("❌ Error completo:", error.response || error);
      toast({
        type: "error",
        message: "No se pudieron cargar los motivos"
      });
      setMotivosOptions([]);
    } finally {
      setLoadingMotivos(false);
    }
  };

  const bindDataModelRemote = async (cleanFilter) => {


    try {

      let prefix = idModule ? "CRUDDynamic" : "CRUD";

      //Now let's load sections
      let querySections = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      let requestSections = await API.getAction(`api/${prefix}/Model`, querySections);
      
      console.log("🔍 RAW Model Response:", requestSections.data);
      
      let recordResultSection = null;
      
      if (Array.isArray(requestSections.data) && requestSections.data.length > 0) {
        if (requestSections.data[0].JSONData) {
          // Caso con JSONData wrapper
          let resultsSections = requestSections.data[0];
          let parsedResultsSections = JSON.parse(resultsSections.JSONData);
          
          const errorData = parsedResultsSections[0] || parsedResultsSections;
          if (errorData && (errorData.Error || errorData.Logout || errorData.Expired)) {
            if (handleApiResponse(errorData)) {
              return;
            }
          }
          
          // El Model puede venir en ReportData o en JSONData
          recordResultSection = parsedResultsSections.ReportData || parsedResultsSections[0]?.JSONData || parsedResultsSections;
          console.log("📊 Model - Con wrapper:", recordResultSection);
        } else {
          // Caso directo
          recordResultSection = requestSections.data;
          console.log("📊 Model - Directo:", recordResultSection);
        }
      }

      //! If grid data stays null, we use the data from the API
      let titles = ['Informacion de auditoria']
      
      // Asegurarse de que recordResultSection sea un objeto, no un array
      let sectionData = Array.isArray(recordResultSection) ? recordResultSection[0] : recordResultSection;
      
      console.log("✅ Final Section Data:", sectionData);
      
      if (sectionData) {
        // Asegurar que sectionData tenga al menos los campos básicos
        const completeSection = {
          FormTitle: sectionData.FormTitle || sectionData.ReportTitle || "Reporte",
          FormPath: sectionData.FormPath || "Reportes",
          FormIcon: sectionData.FormIcon || "fa fa-file",
          Type: sectionData.Type || "report",
          ...sectionData
        };
        
        setSection(completeSection);
        console.log("✅ Section configurado:", completeSection);
        
        if (sectionData.Fields) {
          setFields(sectionData.Fields.filter((item) => !titles.includes(item.FieldTitle)));
          console.log("✅ Fields configurados:", sectionData.Fields.length);
        }
        
        // Cargar filtros dinámicos si existen
        if (sectionData.Filters && sectionData.Filters.length > 0) {
          setFilters(sectionData.Filters);
          console.log("✅ Filtros cargados:", sectionData.Filters);
        } else {
          setFilters([]);
          console.log("⚠️ No hay filtros definidos en el modelo");
        }
      } else {
        console.error("❌ No se pudo obtener sectionData del Model");
      }

    } catch (error) {
      console.error(error);
    } finally {
      //  setLoading(false);
    }
  };
  const [formSize, setFormSize] = useState('md');
  const [tableHeader, setTableHeader] = useState([]);
  useEffect(() => {

  })
  const bindDataHeaderRemote = async (cleanFilter) => {


    try {

      let prefix = idModule ? "CRUDDynamic" : "CRUD";

      //Now let's load sections
      let querySections = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      let requestSections = await API.getAction(`api/${prefix}/Header`, querySections);
      
      console.log("🔍 RAW Header Response:", requestSections.data);
      
      let recordResultSection = null;
      
      if (Array.isArray(requestSections.data) && requestSections.data.length > 0) {
        if (requestSections.data[0].JSONData) {
          // Caso con JSONData wrapper
          let resultsSections = requestSections.data[0];
          let parsedResultsSections = JSON.parse(resultsSections.JSONData);
          
          console.log("📊 Header parsedResults:", parsedResultsSections);
          
          const errorData = parsedResultsSections[0] || parsedResultsSections;
          if (errorData && (errorData.Error || errorData.Logout || errorData.Expired)) {
            if (handleApiResponse(errorData)) {
              return;
            }
          }
          
          recordResultSection = parsedResultsSections.ReportData || parsedResultsSections[0]?.JSONData || parsedResultsSections;
          console.log("📊 Header - Con wrapper:", recordResultSection);
        } else {
          // Caso directo
          recordResultSection = requestSections.data;
          console.log("📊 Header - Directo:", recordResultSection);
        }
      }

      //! If grid data stays null, we use the data from the API
      let titles = ['Informacion de auditoria']
      
      // Asegurarse de que recordResultSection sea un objeto/array
      let headerData = Array.isArray(recordResultSection) ? recordResultSection[0] : recordResultSection;
      
      console.log("✅ Final Header Data:", headerData);
      
      if (headerData) {
        setFormSize(headerData.FormSize ?? 'md');
        
        if (headerData.Fields) {
          setTableHeader(headerData.Fields);
          console.log("✅ Table Header Fields:", headerData.Fields);
        }
      }

    } catch (error) {
      console.error(error);
    } finally {
      //  setLoading(false);
    }
  };

  const initializeFilterDefaults = (filters) => {
    const defaults = {};
    const today = new Date();
    
    filters.forEach(filter => {
      if (filter.Default) {
        // Usar el valor Default del API si existe
        let defaultValue = filter.Default;
        
        // Si el filtro es de tipo date, convertir formato DD-MM-YYYY a YYYY-MM-DD
        if (filter.HtmlType === 'date' && typeof defaultValue === 'string') {
          // Verificar si viene en formato DD-MM-YYYY
          if (defaultValue.includes('-') && defaultValue.length === 10) {
            const parts = defaultValue.split('-');
            if (parts.length === 3 && parts[0].length <= 2) {
              // Convertir de DD-MM-YYYY a YYYY-MM-DD
              defaultValue = `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
          }
        }
        
        defaults[filter.FieldName] = defaultValue;
      } else if (filter.HtmlType === 'date') {
        // Si el filtro es FechaEntrada o contiene "Inicio" -> primer día del mes
        if (filter.FieldName === 'FechaEntrada' || filter.FieldTitle.includes('Inicio')) {
          const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
          defaults[filter.FieldName] = firstDay.toISOString().split('T')[0];
        }
        // Si el filtro es FechaSalida o contiene "Fin" -> último día del mes
        else if (filter.FieldName === 'FechaSalida' || filter.FieldTitle.includes('Fin')) {
          const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          defaults[filter.FieldName] = lastDay.toISOString().split('T')[0];
        }
      } else {
        defaults[filter.FieldName] = '';
      }
    });
    
    return defaults;
  };

  
  /*
    Added by Victor: Actualiza las funciones de getTableHeaders y getTableData para cambiar 
    el tipo de solicitud de POST a GET segun el endpoint de /api/OcupacionProcesos/OcupacionProcesoAsignacion
  */
  // Función para obtener los headers de la tabla principal desde OcupacionProcesos
  const getTableHeaders = async () => {
    try {
      setLoadingFilters(true); // Iniciar carga de filtros
      console.log("🔍 Obteniendo headers de OcupacionProcesos...");
      
      // Obtener primer y último día del mes actual para FechaIni y FechaFin
      const today = new Date();
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      const fechaIni = firstDay.toISOString().split('T')[0];
      const fechaFin = lastDay.toISOString().split('T')[0];
      
      // Construir la URL con los parámetros necesarios, incluyendo FechaIni y FechaFin
      const query = `IdUser=${user.IdUser}&Token=${user.Token}&PageNumber=1&RowsOfPage=10&FechaIni=${fechaIni}&FechaFin=${fechaFin}`;
      
      // Hacer la petición GET al nuevo endpoint
      const response = await API.getAction(`api/OcupacionProcesos/OcupacionProcesoAsignacion?${query}`, null);
      
      console.log("📋 Headers Response:", response.data);
      
      // Verificar que la respuesta existe
      if (response.data && response.data.length > 0) {
        // Parsear JSONData que viene como string
        let firstLevel = JSON.parse(response.data[0].JSONData);
        console.log("📋 Primera capa headers:", firstLevel);
        
        // Verificar errores
        if (firstLevel && (firstLevel.Error || firstLevel.Logout || firstLevel.Expired)) {
          if (handleApiResponse(firstLevel)) {
            return;
          }
        }
        
        // 👇 Extraer Section (FormPath, FormTitle, FormIcon) directamente desde JSONData
        if (firstLevel.JSONData) {
          const sectionData = firstLevel.JSONData;
          console.log("📋 Section data encontrada:", sectionData);
          
          setSection(prev => ({
            ...prev,
            FormPath: sectionData.FormPath || prev.FormPath || "",
            FormTitle: sectionData.FormTitle || prev.FormTitle || "Asignación",
            FormIcon: sectionData.FormIcon || prev.FormIcon || ""
          }));
          console.log("✅ Section actualizada con FormPath:", sectionData.FormPath);
        }
        
        // 👇 NUEVO: Extraer filtros dinámicos
        if (firstLevel.JSONData && firstLevel.JSONData.Filter) {
          const filters = firstLevel.JSONData.Filter;
          console.log("🔍 Filtros dinámicos encontrados:", filters);
          setDynamicFilters(filters);
          
          // Inicializar valores por defecto solo si no hay valores previos
          if (Object.keys(filterValues).length === 0) {
            const defaults = initializeFilterDefaults(filters);
            setFilterValues(defaults);
            console.log("✅ Valores por defecto de filtros:", defaults);
          }
        }
        
        // Extraer Model (headers) desde firstLevel.JSONData.Model
        let headers = [];
        
        if (firstLevel.JSONData && firstLevel.JSONData.Model) {
          headers = firstLevel.JSONData.Model;
          console.log("📋 Headers extraídos desde JSONData.Model:", headers);
        }
        
        // NO filtrar aquí - dejar que cada función decida qué mostrar según ListVisible o Visible
        if (headers && headers.length > 0) {
          const formattedFields = headers
            .map(field => ({
              FieldName: field.FieldName,
              FieldTitle: field.FieldTitle || field.FieldName,
              Alignment: field.Alignment || 'left',
              Visible: field.Visible !== false, // Guardar el valor booleano
              ListVisible: field.ListVisible === true || field.ListVisible === 1, // Normalizar a booleano
              cssClass: field.cssClass || 'col-12 col-md-4',
              HtmlType: field.HtmlType || 'text',
              ReadOnly: field.ReadOnly !== false,
              Sort: field.Sort || false
            }));
          
          // Actualizar el estado de fields con los headers obtenidos
          setFields(formattedFields);
          
          console.log("✅ Headers procesados y actualizados:", formattedFields);
          return formattedFields;
        }
      }
      
    } catch (error) {
      console.error("❌ Error al obtener headers:", error);
      toast({
        type: "error",
        message: "No se pudieron cargar los encabezados de la tabla"
      });
    } finally {
      setLoadingFilters(false); // Finalizar carga de filtros
    }
  };

  // Función para obtener los datos de la tabla desde OcupacionProcesos
  const getTableData = async () => {
    try {
      console.log("🔍 Obteniendo datos de OcupacionProcesos...");
    setLoading(true);
    
    // Construir la URL con los parámetros base
    // Si RecordsQuantity es 0 (Todos), enviar recordCount o un número muy grande
    const rowsOfPage = RecordsQuantity === 0 ? (recordCount || 999999) : RecordsQuantity;
    let query = `IdUser=${user.IdUser}&Token=${user.Token}&PageNumber=${currentPage}&RowsOfPage=${rowsOfPage}`;
    
    // Agregar filtros dinámicos a la query, usando siempre FechaIni y FechaFin
    Object.keys(filterValues).forEach(filterKey => {
      const filterValue = filterValues[filterKey];
      if (filterValue) {
        // Mapear nombres de filtros a los nombres esperados por el API
        let paramName = filterKey;
        
        // Si el campo contiene "entrada" o "inicio", usar FechaIni
        if (filterKey.toLowerCase().includes('entrada') || 
            filterKey.toLowerCase().includes('inicio') ||
            filterKey.toLowerCase().includes('ini')) {
          paramName = 'FechaIni';
        }
        // Si el campo contiene "salida" o "fin", usar FechaFin
        else if (filterKey.toLowerCase().includes('salida') || 
                 filterKey.toLowerCase().includes('fin')) {
          paramName = 'FechaFin';
        }
        
        query += `&${paramName}=${encodeURIComponent(filterValue)}`;
      }
    });
    
    console.log("🔍 Query completo:", query);
    
    // Hacer la petición GET al nuevo endpoint
    const response = await API.getAction(`api/OcupacionProcesos/OcupacionProcesoAsignacion?${query}`, null);
    
    console.log("📊 Data Response:", response.data);
      
      // Verificar que la respuesta existe
      if (response.data && response.data.length > 0) {
        // Parsear JSONData que viene como string
        let firstLevel = JSON.parse(response.data[0].JSONData);
        console.log("📊 Primera capa (parseada):", firstLevel);
        
        // Verificar si hay error
        if (firstLevel && (firstLevel.Error || firstLevel.Logout || firstLevel.Expired)) {
          if (handleApiResponse(firstLevel)) {
            setLoading(false);
            return;
          }
        }

        // Extraer el array de datos desde firstLevel.JSONData.Data
        let dataRows = [];
        
        if (firstLevel.JSONData && firstLevel.JSONData.Data) {
          dataRows = firstLevel.JSONData.Data;
          console.log("📊 Datos extraídos desde JSONData.Data:", dataRows);
        }
        
        // Extraer el conteo total de registros desde Count
        let totalCount = dataRows.length; // Por defecto usar el tamaño del array
        
        if (firstLevel.JSONData && firstLevel.JSONData.Count && Array.isArray(firstLevel.JSONData.Count) && firstLevel.JSONData.Count[0]?.Count !== undefined) {
          totalCount = firstLevel.JSONData.Count[0].Count;
          console.log("📊 Conteo total extraído desde JSONData.Count[0].Count:", totalCount);
        } else if (firstLevel.Count && Array.isArray(firstLevel.Count) && firstLevel.Count[0]?.Count !== undefined) {
          totalCount = firstLevel.Count[0].Count;
          console.log("📊 Conteo total extraído desde Count[0].Count:", totalCount);
        } else {
          console.log("📊 Usando tamaño del array como conteo:", totalCount);
        }
        
        console.log("✅ Datos finales extraídos:", dataRows);
        console.log("✅ Registros en página actual:", dataRows.length);
        console.log("✅ Total de registros:", totalCount);
        if (dataRows.length > 0) {
          console.log("✅ Primer registro (muestra):", dataRows[0]);
        }
        
        // Actualizar el modelo con los datos obtenidos
        setModel({
          ...model,
          data: {
            ...model.data,
            Rows: dataRows
          }
        });
        
        // Actualizar el conteo de registros con el total real
        setRecordCount(totalCount);
        
        // Calcular registros mostrados por página
        const registrosPorPagina = RecordsQuantity === 0 ? totalCount : Math.min(dataRows.length, RecordsQuantity);
        
        toast({
          type: "success",
          message: (
            <div style={{ textAlign: 'left' }}>
              <div>Se encontraron {totalCount} Registro(s)</div>
              {/* <div>Mostrando {registrosPorPagina} Registros por Página</div> */}
            </div>
          )
        });
        
        return dataRows;
      } else {
        // No hay datos
        setModel({
          ...model,
          data: {
            ...model.data,
            Rows: []
          }
        });
        setRecordCount(0);
        
        toast({
          type: "info",
          message: "No se encontraron registros"
        });
      }
      
    } catch (error) {
      console.error("❌ Error al obtener datos:", error);
      toast({
        type: "error",
        message: "No se pudieron cargar los datos de la tabla"
      });
    } finally {
      setLoading(false);
    }
  };

  /*
    Added by Victor: Agrega la funcion getPlazasDisponibles
  */
 // Agregar esta función después de getTableData (alrededor de la línea 837)

  const getPlazasDisponibles = async (idColaborador) => {
    try {
      console.log("🏠 Obteniendo plazas disponibles para colaborador:", idColaborador);
      setLoading(true);
      
      // Construir la query string con los parámetros en la URL
      const query = `ActionMode=PD&IdColaborador=${idColaborador}&JsonParams=${encodeURIComponent("{}")}&Token=${user.Token}`;
      
      console.log("🔍 Query completo:", query);
      console.log("🔍 URL completa:", `api/OcupacionProcesos/OcupacionProcesoAsignacionHelper?${query}`);
      
      // Hacer la petición POST con los parámetros en la URL
      const response = await API.postAction(
        `api/OcupacionProcesos/OcupacionProcesoAsignacionHelper?${query}`,
        null  // Body vacío o null
      );
      
      console.log("📥 Plazas Response:", response.data);
      
      // Verificar que la respuesta existe
      if (response.data && response.data.length > 0) {
        // Parsear el primer nivel de JSONData
        let firstLevel = JSON.parse(response.data[0].JSONData);
        console.log("📋 Primera capa parseada:", firstLevel);
        
        // Verificar errores
        if (firstLevel && (firstLevel.Error || firstLevel.Logout || firstLevel.Expired)) {
          if (handleApiResponse(firstLevel)) {
            setDetailItems([]);
            setLoading(false);
            return;
          }
        }
        
        // Extraer Model (headers) y Data (plazas)
        let plazasHeaders = [];
        let plazasData = [];
        
        if (firstLevel.JSONData && firstLevel.JSONData.Model) {
          plazasHeaders = firstLevel.JSONData.Model;
          console.log("📋 Headers de plazas:", plazasHeaders);

          setPlazasHeaders(plazasHeaders);
        }
        
        if (firstLevel.JSONData && firstLevel.JSONData.Data) {
          plazasData = firstLevel.JSONData.Data;
          console.log("🏠 Plazas disponibles:", plazasData);
        }
        
        // Actualizar el estado con las plazas obtenidas
        setDetailItems(plazasData);
        setSelectedPlaza(null);
        setSelectedPlazaIndex(null);
        
        console.log("✅ Plazas cargadas exitosamente:", plazasData.length);
        
        toast({
          type: "success",
          message: `Se encontraron ${plazasData.length} plaza(s) disponible(s)`
        });
        
        return { headers: plazasHeaders, data: plazasData };
      } else {
        // No hay datos
        setDetailItems([]);
        
        toast({
          type: "info",
          message: "No se encontraron plazas disponibles"
        });
      }
      
    } catch (error) {
      console.error("❌ Error al obtener plazas:", error);
      toast({
        type: "error",
        message: "No se pudieron cargar las plazas disponibles"
      });
      setDetailItems([]);
    } finally {
      setLoading(false);
    }
  };

  // Función para enviar respuesta del diálogo cuando se hace clic en "No"
  const handleDialogResponse = async (dialogText, dialogResp) => {
    try {
      console.log("📝 Enviando respuesta del diálogo...");
      setLoading(true);
      
      // Construir la query string solo con DialogText y DialogResp (sin hacer asignación)
      const query = `ActionMode=AP&IdColaborador=${selectedItem.Id}&JsonParams=${encodeURIComponent("{}")}&Token=${user.Token}&IdPlaza=${selectedPlaza.Id}&FechaAsignacion=${fechaAsignacion}&IdMotivo=${selectedMotivo}&Comentario=${encodeURIComponent(comentarioAsignacion)}&DialogText=${encodeURIComponent(dialogText)}&DialogResp=${encodeURIComponent(dialogResp)}`;
      
      console.log("🔍 Query diálogo (No):", query);
      console.log("📤 Respuesta del diálogo:");
      console.log("  - DialogText:", dialogText);
      console.log("  - DialogResp:", dialogResp);
      console.log("  - IdMotivo:", selectedMotivo);
      console.log("  - FechaAsignacion:", fechaAsignacion);
      
      // Hacer la petición POST
      const response = await API.postAction(
        `api/OcupacionProcesos/OcupacionProcesoAsignacionHelper?${query}`,
        null
      );
      
      console.log("📥 Response del diálogo:", response.data);
      
      setLoading(false);
    } catch (error) {
      console.error("❌ Error al enviar respuesta del diálogo:", error);
      setLoading(false);
    }
  };

  // Función para asignar una plaza a un colaborador
const handleAsignarPlaza = async (dialogText, dialogResp) => {
  try {
    console.log("🏠 Asignando plaza al colaborador...");
    setLoading(true);
    
    // Construir la query string con los parámetros en la URL, incluyendo DialogText y DialogResp
    const query = `ActionMode=AP&IdColaborador=${selectedItem.Id}&JsonParams=${encodeURIComponent("{}")}&Token=${user.Token}&IdPlaza=${selectedPlaza.Id}&FechaAsignacion=${fechaAsignacion}&IdMotivo=${selectedMotivo}&Comentario=${encodeURIComponent(comentarioAsignacion)}&DialogText=${encodeURIComponent(dialogText)}&DialogResp=${encodeURIComponent(dialogResp)}`;
    
    console.log("🔍 Query completo:", query);
    console.log("📤 Datos de asignación:");
    console.log("  - Colaborador:", selectedItem.Id, selectedItem.Nombre);
    console.log("  - Plaza:", selectedPlaza.Id, selectedPlaza.Plaza);
    console.log("  - FechaAsignacion:", fechaAsignacion);
    console.log("  - IdMotivo:", selectedMotivo);
    console.log("  - Comentario:", comentarioAsignacion);
    console.log("  - DialogText:", dialogText);
    console.log("  - DialogResp:", dialogResp);
    
    // Hacer la petición POST con los parámetros en la URL
    const response = await API.postAction(
      `api/OcupacionProcesos/OcupacionProcesoAsignacionHelper?${query}`,
      null  // Body vacío
    );
    
    console.log("📥 Response de asignación:", response.data);
    
    // Verificar que la respuesta existe
    if (response.data && response.data.length > 0) {
      // Parsear el primer nivel de JSONData
      let firstLevel = JSON.parse(response.data[0].JSONData);
      console.log("📋 Respuesta parseada:", firstLevel);
      
      // Verificar errores
      if (firstLevel.Error) {
        toast({
          type: "error",
          message: firstLevel.Msg || "Error al asignar la plaza"
        });
        setLoading(false);
        return false;
      }
      
      // Asignación exitosa
      console.log("✅ Plaza asignada correctamente");
      
      // Cerrar el modal de asignación
      toggleOpen(null, false);
      
      // Recargar la tabla de colaboradores
      await getTableData();
      
      // Mostrar modal de éxito personalizado
      confirmAlert({
        closeOnClickOutside: false,
        customUI: ({ onClose }) => {
          return (
            <CustomModal
              type="success"
              title="¡Acción Completada!"
              message="¡La Asignación ha sido completada exitosamente!"
              primaryButtonText="Continuar"
              onPrimaryClick={() => { 
                // Modal cerrado automáticamente
              }}
              onClose={onClose}
            />
          );
        }
      });
      
      return true;
    } else {
      toast({
        type: "error",
        message: "No se recibió respuesta del servidor"
      });
      return false;
    }
    
  } catch (error) {
    console.error("❌ Error al asignar plaza:", error);
    toast({
      type: "error",
      message: "No se pudo asignar la plaza. Por favor, intente nuevamente."
    });
    return false;
  } finally {
    setLoading(false);
  }
};

  // useEffect(() => { 
  //   if (checkAudit !== null) {
  //     bindDataRemote();
  //   }
  // }, [checkAudit, bindDataRemote])

  // const bindDataDetailsRemote = async (recordId) => {
  //   //First load records
  //   try {
  //     let prefix = idModule ? "CRUDDynamic" : "CRUD";
  //     let query = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}&RecordId=${recordId}${idModule ? "&IdModule=" + idModule : ""}`;
  //     let request = await API.getAction(`api/${prefix}/Details`, query);
  //     let results = request.data[0];

  //     let parsedResults = JSON.parse(results.JSONData)[0];
  //     if (parsedResults.Error) {
  //       alert(parsedResults.Msg);
  //       return;
  //     }

  //     let finalResult = parsedResults.JSONData;
  //     fillFormikObject(finalResult);
  //     setSelectedItem(null);
  //     setSelectedItemIndex(null);
  //   } catch (error) {
  //     console.error(error)
  //   }
  //   //Fill object with new values
  // };

  //Open edit/add mode
  // const toggleOpen = async (action, reload) => {
  //   setActionMode(action);

  //   if (action === null) {
  //     setSelectedItem(null);
  //     setSelectedItemIndex(null);
  //     // Restaurar la tabla de detalle al cerrar
  //     setDetailItems([
  //       {
  //         Id: 686,
  //         Codigo: "V03-202-3A",
  //         Plaza: "VILLA 03 PISO 2 APT 02 HAB 3 PLAZA A",
  //         Categoria: "EJECUTIVO",
  //         Estado: "PLAZA PENDIENTE SALIDA",
  //         Ocupante: "BELGICA GERALDINE CHIRINOS ACOSTA",
  //         FechaSalida: "28-04-2025",
  //         MotivoSalida: "ENTREGA VOLUNTARIA",
  //         ComentarioSalida: "SALIDA POR ENTREGA VOLUNTARIA EL 28-04-2025"
  //       },
  //       {
  //         Id: 703,
  //         Codigo: "E01-303-3A",
  //         Plaza: "EDIF. 01 PISO 3 APT 03 HAB 3 PLAZA A",
  //         Categoria: "EJECUTIVO",
  //         Estado: "PLAZA PENDIENTE SALIDA",
  //         Ocupante: "BENARDO RAMON D. ZIMMERMANN DIAZ",
  //         FechaSalida: "01-08-2025",
  //         MotivoSalida: "ENTREGA VOLUNTARIA",
  //         ComentarioSalida: "SALIDA POR ENTREGA VOLUNTARIA EL 01-08-2025"
  //       },
  //       {
  //         Id: 880,
  //         Codigo: "E08-501-4A",
  //         Plaza: "EDIF. 08 PISO 5 APT 01 HAB 4 PLAZA A",
  //         Categoria: "EJECUTIVO",
  //         Estado: "PLAZA PENDIENTE SALIDA",
  //         Ocupante: "CARLOS MARTIN LOPEZ",
  //         FechaSalida: "30-04-2025",
  //         MotivoSalida: "ENTREGA VOLUNTARIA",
  //         ComentarioSalida: "SALIDA POR ENTREGA VOLUNTARIA EL 30-04-2025"
  //       },
  //       {
  //         Id: 1016,
  //         Codigo: "E08-103-4A",
  //         Plaza: "EDIF. 08 PISO 1 APT 03 HAB 4 PLAZA A",
  //         Categoria: "EJECUTIVO",
  //         Estado: "DISPONIBLE PARA USO",
  //         Ocupante: "CHELSEA IRIS GARCIA BAEZ",
  //         FechaSalida: "28-06-2025",
  //         MotivoSalida: "BAJA",
  //         ComentarioSalida: "SALIDA POR BAJA EL 28-06-2025"
  //       }
  //     ]);
  //     setNewDetailItem({ campo1: '', campo2: '' });
  //     // Limpiar los campos de asignación
  //     setSelectedCodigo('');
  //     setSelectedNombre('');
  //     setSelectedGenero('');
  //     setSelectedFechaNac('');
  //     setSelectedEdad('');
  //     setSelectedTipo('');
  //     setSelectedCategoria('');
  //     setSelectedDepartamento('');
  //     setSelectedNivelPuesto('');
  //     setSelectedCargo('');
  //     setSelectedTipoVivienda('');
  //   }

  //   // Si estamos abriendo el modal en modo editar (U) o consultar (C)
  //   if ((action === "U" || action === "C") && selectedItem) {
  //     console.log("📝 Llenando campos con datos del registro seleccionado:", selectedItem);
      
  //     // Llenar los SelectBox con los valores del registro seleccionado
  //     setSelectedCodigo(selectedItem.Codigo || '');
  //     setSelectedNombre(selectedItem.Nombre || '');
  //     setSelectedGenero(selectedItem.Genero || '');
  //     setSelectedFechaNac(selectedItem.FechaNac || '');
  //     setSelectedEdad(selectedItem.Edad || '');
  //     setSelectedTipo(selectedItem.Tipo || '');
  //     setSelectedCategoria(selectedItem.Categoria || '');
  //     setSelectedDepartamento(selectedItem.Departamento || '');
  //     setSelectedNivelPuesto(selectedItem.NivelPuesto || '');
  //     setSelectedCargo(selectedItem.Cargo || '');
  //     setSelectedTipoVivienda(selectedItem.TipoVivienda || '');
  //   }

  //   if (action === "I") {
  //     setSelectedItem(null);
  //     setSelectedItemIndex(null);
  //   }

  //   if (selectedItemRef.current) {
  //     selectedItemRef.current.clearSelection();
  //   }

  //   setGeneralError(null);
  //   setOpen(!open);
  //   if (reload) {
  //     bindDataRemote();
  //   }
  // };

  const toggleOpen = async (action, reload, itemToEdit = null) => {
    setActionMode(action);

    if (action === null) {
      setSelectedItem(null);
      setSelectedItemIndex(null);
      // Restaurar la tabla de detalle al cerrar
      setDetailItems([]);
      setNewDetailItem({ campo1: '', campo2: '' });
      // Limpiar los campos de asignación
      setSelectedCodigo('');
      setSelectedNombre('');
      setSelectedGenero('');
      setSelectedFechaNac('');
      setSelectedEdad('');
      setSelectedTipo('');
      setSelectedCategoria('');
      setSelectedDepartamento('');
      setSelectedNivelPuesto('');
      setSelectedCargo('');
      setSelectedTipoVivienda('');
      setPlazasHeaders([]);
      setSelectedPlaza(null);
      setSelectedPlazaIndex(null);
      setComentarioAsignacion('');
      // Limpiar campo de motivo
      setSelectedMotivo(null);
      setFechaAsignacion(''); // Limpiar fecha de asignación
      setValidationErrors({}); // Limpiar errores de validación
    }
  
    // Si estamos abriendo el modal en modo editar (U) o consultar (C)
    // Usar itemToEdit si se proporciona, sino usar selectedItem del estado
    const itemData = itemToEdit || selectedItem;
    
    if ((action === "U" || action === "C") && itemData) {
      console.log("📝 Llenando campos con datos del registro seleccionado:", itemData);
      
      // Establecer fecha actual por defecto para la asignación
      const today = new Date().toISOString().split('T')[0];
      setFechaAsignacion(today);
      
      // Actualizar selectedItem en el estado si viene itemToEdit
      if (itemToEdit) {
        setSelectedItem(itemToEdit);
      }
      
      // Llenar los SelectBox con los valores del registro seleccionado
      setSelectedCodigo(itemData.Codigo || '');
      setSelectedNombre(itemData.Nombre || '');
      setSelectedGenero(itemData.Genero || '');
      setSelectedFechaNac(itemData.FechaNac || '');
      setSelectedEdad(itemData.Edad || '');
      setSelectedTipo(itemData.Tipo || '');
      setSelectedCategoria(itemData.Categoria || '');
      setSelectedDepartamento(itemData.Departamento || '');
      setSelectedNivelPuesto(itemData.NivelPuesto || '');
      setSelectedCargo(itemData.Cargo || '');
      setSelectedTipoVivienda(itemData.TipoVivienda || '');
      
      // ⭐ NUEVO: Obtener las plazas disponibles para este colaborador
      if (itemData.Id) {
        await getPlazasDisponibles(itemData.Id);
      } else {
        console.warn("⚠️ No se encontró Id en itemData");
        toast({
          type: "warning",
          message: "No se pudo identificar el colaborador seleccionado"
        });
      }
    }

    if (action === "I") {
      setSelectedItem(null);
      setSelectedItemIndex(null);
    }

    if (selectedItemRef.current) {
      selectedItemRef.current.clearSelection();
    }

    setGeneralError(null);
    setOpen(!open);
    
    // Cargar motivos cuando se abre el modal
    if (action !== null) {
      await loadMotivosOptions();
    }
    
    if (reload) {
      // Recargar datos después de guardar
      await getTableData();
    }
  };

  //Delete the record
  const deleteConfirm = async (obj) => {
    const mensajeConfirmacion = "¿Confirma que desea eliminar este registro?";
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <CustomModal
            type="error"
            title="¡Confirmar Acción!"
            message={mensajeConfirmacion}
            icon="fa-messages-question"
            primaryButtonText="Continuar"
            secondaryButtonText="Cancelar"
            onPrimaryClick={async () => {
              let prefix = idModule ? "CRUDDynamic" : "CRUD";
              let query = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}&RecordId=${selectedItem.GUID}${idModule ? "&IdModule=" + idModule : ""}`;
              await API.getAction(`api/${prefix}/Delete`, query);
              await bindDataRemote();
              setSelectedItem(null);
              setSelectedItemIndex(null);
            }}
            onSecondaryClick={() => {
              // Solo cerrar el modal
            }}
            onClose={onClose}
          />
        );
      }
    });
  };

  //Update the field value on formik according to what has been updated
  const updateField = (fieldName, fieldValue) => {
    formik.setFieldValue(fieldName, fieldValue);
  };



  const [validationsSchema, setValidationSchema] = useState(null);

  const fillFormikObject = (record) => {
    //debugger;
    console.log("record", record, "model", section);
    if (
      section &&
      fields &&
      fields.length > 0
    ) {
      fields.forEach((item) => {
        console.log(
          "field name",
          item.FieldName,
          "RecordValue ",
          record[item.FieldName]
        );
        formik.setFieldValue(item.FieldName, record[item.FieldName]);
      });
    }

    //Now
  };

  const prepareFormikObject = () => {
    // console.log("Preparing formik object", section)
    let initialObject = {};
    let initialObjectValidation = {};

    if (fields) {
      fields.forEach((item) => {
        initialObject[item.FieldName] = item.value;

        if (item.Required) {
          initialObjectValidation[item.FieldName] = yupTypeValidator(item);
        }
      });
    }
    formik.initialValues = initialObject;

    console.log("initialObject", initialObject)

    setValidationSchema(yup.object(initialObjectValidation));
    //Now
  };

  //This method is to save the record we are working on
  const handleSubmit = async (obj, event) => {
    console.log("❗ ~ file: CRUDSimple.js:259 ~ handleSubmit ~ obj:", obj)
    console.log({ fields: fields })
    let actions = {
      "I": "I",
      "U": "U",
      "D": "I"
    };

    if (actionMode === "D") {
      const { GUID, Id, ...rest } = obj;
      obj = rest;
    }


    confirmAlert({
      closeOnClickOutside: false,
      message: "Estas seguro de querer guardar este registro?",
      buttons: [
        {
          label: "Si",
          onClick: async () => {
            let objSPVersion = "";
            fields.forEach((item) => {

              if (item.ReadOnly || item.HtmlType === "separator") return;

              if (item.HtmlType !== "separator") {
                objSPVersion +=
                  (objSPVersion.length > 0 ? ", " : "") + `@${item.FieldName}=`;
              }
              if (
                item.FieldType === "int" ||
                item.FieldType === "bool" ||
                item.FieldType === "bit" ||
                item.FieldType === "bigint"
              ) {
                objSPVersion +=
                  obj[item.FieldName] === undefined || obj[item.FieldName] === null
                    ? item.DefaultValue && item.DefaultValue.length > 0 ? item.DefaultValue : "null"
                    : "'" + obj[item.FieldName] + "'";

              } else if (item.HtmlType === "password") {
                let passwordEncrypted = null;
                if (obj[item.FieldName] && obj[item.FieldName].length > 0) {
                  passwordEncrypted =
                    obj["UserName"].toUpperCase() + obj[item.FieldName];
                  passwordEncrypted = Sha256.hash(passwordEncrypted);
                  ;
                }
                objSPVersion +=
                  obj[item.FieldName] === undefined
                    ? "null"
                    : "'" + passwordEncrypted + "'"
              } else
                if (item.HtmlType === 'radio') {

                  objSPVersion +=
                    obj[item.FieldName] === undefined || obj[item.FieldName] === null
                      ? item.DefaultValue && item.DefaultValue.length > 0 ? item.DefaultValue : "null"
                      : "'" + obj[item.FieldName] + "'";
                } else {
                  objSPVersion +=
                    obj[item.FieldName] === undefined || obj[item.FieldName] === null
                      ? "null"
                      : "'" + obj[item.FieldName] + "'";
                }
            });

            let queryString = `IdUser=${user.IdUser}&id=${params.id}&Token=${user.Token}&ActionMode=${actions[actionMode]}${idModule ? "&IdModule=" + idModule : ""}`;
            let queryData = {
              Data: objSPVersion,
            };

            let prefix = idModule ? "CRUDDynamic" : "CRUD";
            let request = await API.postAction(
              `api/${prefix}/AddEdit?${queryString}`,
              queryData
            );

            if (request.status === 200) {
              let response = JSON.parse(request.data[0].JSONData)[0];
              //debugger;
              if (response.Error) {
                setGeneralError(response.Msg);
                return;
              }
            }
            setGeneralError(null);
            setSelectedItem(null);
            setSelectedItemIndex(null);

            formik.resetForm();

            toast({
              type: "success",
              "message": "Registro guardado correctamente",
            })
            toggleOpen(null, true);
          },
        },
        {
          label: "No",
        },
      ],
    });


  };

  const formik = useFormik({
    initialValues: {},
    enableReinitialize: true,

    validateOnChange: false,
    validateOnBlur: false,

    validationSchema: validationsSchema,
    onSubmit: handleSubmit,
  });


  const addFavorite = async () => {

    const newFavorite = {
      icon: `${section.FormIcon}`,
      path: pathname,
      formPath: section.FormPath,
      title: section.FormTitle,
    }
    UpdateFavorites(newFavorite)

  }

  const headerWithoutAuditFields = () => {
    // Para reportes, usar Fields del Model si tableHeader está vacío
    let headers = tableHeader && tableHeader.length > 0 ? tableHeader : fields;
    
    console.log("🔍 headerWithoutAuditFields - tableHeader:", tableHeader);
    console.log("🔍 headerWithoutAuditFields - fields:", fields);
    console.log("🔍 headerWithoutAuditFields - usando:", headers);
    
    // Normalizar headers para que tengan FieldTitle (reportes usan ListTitle)
    const normalizedHeaders = headers && headers.map(header => ({
      ...header,
      FieldTitle: header.FieldTitle || header.ListTitle || header.FieldName
    }));
    
    return normalizedHeaders && normalizedHeaders
      .filter(x =>
        x.FieldTitle !== "Audit Information"
        && x.FieldName !== "Id"
        && x.FieldName !== "IdUserAdd"
        && x.FieldName !== 'DateAdd'
        && x.FieldName !== 'IdUserMod'
        && x.FieldName !== 'DateMod'
        && (x.ListVisible === true || x.ListVisible === 1) // Solo mostrar si ListVisible es true o 1
      )
  }

  // Función helper para obtener la alineación de una columna
  const getColumnAlignment = (columnName) => {
    // Primero buscar en fields (donde viene el Alignment del Model)
    if (fields && fields.length > 0) {
      const field = fields.find(f => f.FieldName === columnName);
      if (field && field.Alignment) {
        return field.Alignment;
      }
    }
    
    // Fallback: buscar en model.data.Alignment (compatibilidad con versión anterior)
    if (model?.data?.Alignment && model.data.Alignment.length > 0) {
      const alignmentItem = model.data.Alignment.find(a => a.ColumnName === columnName);
      if (alignmentItem) {
        return alignmentItem.Align;
      }
    }
    
    return 'left'; // Alineación por defecto
  }

  // Función helper para convertir alignment a clase de Bootstrap justify-content para HEADERS
  // Solo respeta "right", todo lo demás (left, center, undefined) va centrado
  const getHeaderJustifyClass = (alignment) => {
    if (alignment === 'right') {
      return 'justify-content-end';
    }
    return 'justify-content-center'; // Por defecto centrado para headers
  }

  // Modified by Frandy para exportar solo las columnas visibles
  const exportToExcel = useCallback(async () => {

    const visibleColumns = headerWithoutAuditFields();
    
    const excelData = model.data.Rows && model.data.Rows.map((item) => {
      return visibleColumns.reduce((acc, column) => {
        acc[column.FieldName] = item[column.FieldName];
        return acc;
      }, {});

    });
  
    GenerateXLS(excelData, `${section.FormTitle}.xlsx`);

  }, [model.data.Rows, tableHeader, section]);

  const exportToPDF = useCallback(async () => {
    const container = document.getElementById("contentContainer");
    if (container) {
      await GeneratePDF(container, "landscape", section?.FormTitle || "Registro");
    } else {
      console.error("No se encontró el contenedor para exportar a PDF");
      alert("Error: No se puede exportar el contenido. Elemento no encontrado.");
    }
    // GeneratePDF(container);
  }, [section])

  // Add by Victor: Agrega el handlePrint para imprimir el contenido de la pantalla
  const handlePrint = useCallback(() => {
    // Crear el HTML de la tabla
    const visibleColumns = headerWithoutAuditFields();
    
    const tableHTML = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>${section?.FormTitle || 'Tabla'}</title>
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />
          <style>
            @media print {
              @page {
                margin: 1cm;
                size: landscape;
              }
              body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
            }
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
            }
            h4 {
              text-align: center;
              font-weight: bold;
              margin-bottom: 20px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              border: 1px solid #000;
            }
            th {
              background-color: #6c757d;
              color: white;
              font-weight: bold;
              padding: 8px;
              border: 1px solid #000;
              text-align: left;
            }
            td {
              padding: 8px;
              border: 1px solid #000;
            }
            tr:nth-child(even) {
              background-color: #f2f2f2;
            }
          </style>
        </head>
        <body>
          <h4>${section?.FormTitle || 'Tabla'}</h4>
          <table>
            <thead>
              <tr>
                ${visibleColumns.map(column => {
                  const alignment = getColumnAlignment(column.FieldName);
                  const headerAlign = alignment === 'right' ? 'right' : 'center';
                  return `<th style="text-align: ${headerAlign};">${column.FieldTitle}</th>`;
                }).join('')}
              </tr>
            </thead>
            <tbody>
              ${model?.data?.Rows?.map((item) => {
                return `<tr>
                  ${visibleColumns.map((column) => {
                    const alignment = getColumnAlignment(column.FieldName);
                    let cellValue = '';
                    
                    // Si es la columna Icon, renderizar el icono en HTML
                    if (column.FieldName === "Icon" && item[column.FieldName]) {
                      const rawValue = item[column.FieldName];
                      
                      // Intentar parsear si es un string JSON con array de iconos
                      let parsedIcons = null;
                      if (typeof rawValue === 'string' && (rawValue.trim().startsWith('[') || rawValue.trim().startsWith('{'))) {
                        try {
                          // Limpiar el JSON: eliminar comas antes de ] o }
                          let cleanedJson = rawValue
                            .replace(/,(\s*[\]}])/g, '$1') // Eliminar comas antes de ] o }
                            .replace(/\r\n/g, '') // Eliminar saltos de línea \r\n
                            .replace(/\n/g, ''); // Eliminar saltos de línea \n
                          
                          parsedIcons = JSON.parse(cleanedJson);
                        } catch (e) {
                          // Si falla el parseo, continuar con el flujo normal
                        }
                      }
                      
                      // Si logramos parsear un array de iconos estructurados
                      if (Array.isArray(parsedIcons) && parsedIcons.length > 0 && parsedIcons[0].icon) {
                        cellValue = parsedIcons.map(iconObj => {
                          const isDisabled = iconObj.Enabled === "false" || iconObj.Enabled === false;
                          const opacity = isDisabled ? 0.3 : 1;
                          const color = isDisabled ? '#ccc' : '#000';
                          return `<i class="${iconObj.icon}" style="font-size: 1.2rem; margin: 0 10px; cursor: pointer; color: ${color}; opacity: ${opacity};" title="${iconObj.Name || ''}"></i>`;
                        }).join('');
                      }
                      // Formato antiguo: Detectar si el valor es un icono (string)
                      else if (typeof rawValue === 'string' && (rawValue.includes('fa-') || rawValue.includes('icon-'))) {
                        // Limpiar y dividir múltiples iconos si existen
                        const cleanIconClass = rawValue
                          .replace(/\r\n/g, '')
                          .replace(/\n/g, '')
                          .replace(/\\/g, '')
                          .trim();
                        cellValue = `<i class="${cleanIconClass}" style="font-size: 1.2rem; margin: 0 10px; cursor: pointer; display: inline-block;"></i>`;
                      } else {
                        cellValue = rawValue;
                      }
                      
                      return `<td style="text-align: center; vertical-align: middle;">${cellValue}</td>`;
                    }
                    
                    if (column.FieldType === "datetime" || column.FieldType === "date") {
                      cellValue = moment(item[column.FieldName]).format("MM/DD/YYYY");
                    } else if (typeof item[column.FieldName] === 'boolean') {
                      cellValue = item[column.FieldName] ? 'Sí' : 'No';
                    } else {
                      cellValue = item[column.FieldName] || '';
                    }
                    return `<td style="text-align: ${alignment};">${cellValue}</td>`;
                  }).join('')}
                </tr>`;
              }).join('') || ''}
            </tbody>
            ${model?.data?.Summary && model.data.Summary.length > 0 ? `
              <tfoot>
                <tr style="background-color: #e9ecef; font-weight: bold;">
                  ${visibleColumns.map((column) => {
                    const summaryItem = model.data.Summary.find(s => s.ColumnName === column.FieldName);
                    const alignment = getColumnAlignment(column.FieldName);
                    const summaryAlign = alignment === 'right' ? 'right' : 'center';
                    return `<td style="font-weight: bold; text-align: ${summaryAlign};">${summaryItem ? summaryItem.SummValue.toLocaleString('en-US') : ''}</td>`;
                  }).join('')}
                </tr>
              </tfoot>
            ` : ''}
          </table>
        </body>
      </html>
    `;

    // Crear un iframe temporal oculto
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);

    // Escribir el contenido en el iframe
    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(tableHTML);
    iframeDoc.close();

    // Esperar a que se cargue y luego imprimir
    iframe.onload = () => {
      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        
        // Remover el iframe después de imprimir
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      }, 250);
    };
  }, [model?.data?.Rows, tableHeader, section])

  // END METHODS

  // UI METHODS

  // REMOVIDO: bindDataRemote ya tiene sortBy y sortByOrder en sus dependencias del useCallback
  // useEffect(() => {
  //   console.log("entro", new Date())
  //   bindDataRemote();
  // }, [sortBy, sortByOrder])

  const loadGRIDUI = () => {
    // SIN MAXIMIZAR (isSearching=true): tabla con altura limitada para evitar paginación muy abajo
    // MAXIMIZADO (isSearching=false): scroll interno, paginación fija al final
    const tableScrollMaxHeight = isSearching
      ? 'calc(100vh - 430px)' // CON filtros: altura limitada, paginación siempre visible
      : `calc(100vh - 270px)`; // Maximizado: scroll interno amplio, paginación fija abajo
    
    const tableOverflowY = isSearching
      ? 'auto' // CON filtros: con scroll interno para mantener paginación visible
      : 'auto'; // Maximizado: con scroll interno
    
    return (
      <>
      
        <Container>
          <Row
            // className="mx-2"
          >

            <div className="crud-table-outer">
              <div
                className="crud-table-scroll"
                style={{
                  maxHeight: tableScrollMaxHeight,
                  minHeight: "auto",
                  overflowY: tableOverflowY,
                  ["--app-sticky-top"]: `0px`,
                  borderRadius: '7px',
                  paddingBottom: '1rem',
                }}
              >
            <Table hover size="xl" bordered className="crud-table border shadow-sm " >
              <thead className="table-secondary crud-table-thead">
                <tr>
                  {headerWithoutAuditFields()
                    .map((item, index) => {
                      const alignment = getColumnAlignment(item.FieldName);
                      const justifyClass = getHeaderJustifyClass(alignment);
                      return (
                        <th key={index} className={`fw-bold crud-table-th`} style={{ textAlign: alignment === 'right' ? 'right' : 'center' }}>
                          <div className={`d-flex ${justifyClass} align-items-center`}>
                            <span 
                              className="clickable"
                              onClick={() => {
                                setSortBy(item.FieldName);
                                if (item.FieldName === sortBy) {
                                  if (sortByOrder === 'ASC') {
                                    setSortByOrder('DESC')
                                  } else {
                                    setSortByOrder('ASC')
                                  }
                                } else {
                                  setSortByOrder('ASC')
                                }
                              }}
                            >
                              {item.FieldTitle} 
                              {sortBy === item.FieldName && sortByOrder === 'ASC' ? 
                                <i className="fas fa-sort-up ms-1"></i> : 
                                sortBy === item.FieldName && sortByOrder === 'DESC' ? 
                                <i className="fas fa-sort-down ms-1"></i> : null
                              }
                            </span>
                          </div>
                        </th>
                      )
                    })}
                </tr>
              </thead>
              <tbody>
                {model?.data && model.data.Rows.map((item, index) => {
                  return (
                    <tr 
                      key={index} 
                      onClick={() => { 
                        setSelectedItem(item);
                        setSelectedItemIndex(index);
                      }} 
                      className={selectedItemIndex === index ? "active" : ""}
                    >
                      {headerWithoutAuditFields()
                        .map((column, index2) => {
                          const alignment = getColumnAlignment(column.FieldName);
                          
                          // Si es la columna Icon, renderizar el icono clickeable
                          if (column.FieldName === "Icon" && item[column.FieldName]) {
                            const cellValue = item[column.FieldName];
                            
                            // Intentar parsear si es un string JSON con array de iconos
                            let parsedIcons = null;
                            if (typeof cellValue === 'string' && (cellValue.trim().startsWith('[') || cellValue.trim().startsWith('{'))) {
                              try {
                                // Limpiar el JSON: eliminar comas antes de ] o }
                                let cleanedJson = cellValue
                                  .replace(/,(\s*[\]}])/g, '$1') // Eliminar comas antes de ] o }
                                  .replace(/\r\n/g, '') // Eliminar saltos de línea \r\n
                                  .replace(/\n/g, ''); // Eliminar saltos de línea \n
                                
                                parsedIcons = JSON.parse(cleanedJson);
                              } catch (e) {
                                // Si falla el parseo, continuar con el flujo normal
                                console.warn(`⚠️ No se pudo parsear el JSON de iconos:`, cellValue, e);
                              }
                            }
                            
                            // Si logramos parsear un array de iconos estructurados
                            if (Array.isArray(parsedIcons) && parsedIcons.length > 0 && parsedIcons[0].icon) {
                              return (
                                <td 
                                  key={index2} 
                                  className="text-center" 
                                  style={{ 
                                    textAlign: 'center',
                                    verticalAlign: 'middle'
                                  }}
                                >
                                  <div className="d-flex justify-content-center align-items-center gap-3">
                                    {parsedIcons.map((iconObj, iconIdx) => {
                                      const isDisabled = iconObj.Enabled === "false" || iconObj.Enabled === false;
                                      const iconClass = iconObj.icon;
                                      
                                      return (
                                        <i 
                                          key={iconIdx}
                                          className={iconClass} 
                                          style={{ 
                                            fontSize: '1.2rem', 
                                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                                            color: isDisabled ? '#ccc' : '#000000',
                                            opacity: isDisabled ? 0.5 : 1,
                                            display: 'inline-block'
                                          }}
                                          onClick={!isDisabled ? (e) => {
                                            e.stopPropagation(); // Evitar que se propague al tr
                                            setSelectedItemIndex(index);
                                            toggleOpen("U", false, item); // Pasar el item directamente
                                          } : undefined}
                                          title={iconObj.Name || 'Asignar plaza'}
                                        ></i>
                                      );
                                    })}
                                  </div>
                                </td>
                              );
                            }
                            // Formato antiguo: Icono simple como string
                            else {
                              const cleanIconClass = cellValue
                                .replace(/\r\n/g, '')
                                .replace(/\n/g, '')
                                .replace(/\\/g, '')
                                .trim();
                              
                              return (
                                <td 
                                  key={index2} 
                                  className="text-center" 
                                  style={{ 
                                    textAlign: 'center',
                                    verticalAlign: 'middle'
                                  }}
                                >
                                  <i 
                                    className={cleanIconClass} 
                                    style={{ 
                                      fontSize: '1.2rem', 
                                      cursor: 'pointer',
                                      color: '#000000',
                                      display: 'inline-block'
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation(); // Evitar que se propague al tr
                                      setSelectedItemIndex(index);
                                      toggleOpen("U", false, item); // Pasar el item directamente
                                    }}
                                    title="Asignar plaza"
                                  ></i>
                                </td>
                              );
                            }
                          }
                          
                          if (column.FieldType === "datetime" || column.FieldType === "date") {
                            return (
                              <td key={index2} className={` `} style={{ textAlign: alignment }}>{moment(item[column.FieldName]).format("MM/DD/YYYY")}</td>
                            )
                          }

                          return (
                            <td key={index2} className={` `} style={{ textAlign: alignment }}>{
                              (typeof item[column.FieldName] === 'boolean') ? <input type="checkbox" checked={item[column.FieldName]} className="" readOnly /> : item[column.FieldName]
                            }</td>
                          )
                        })}
                    </tr>
                  )
                })}
              </tbody>
              {model?.data?.Summary && model.data.Summary.length > 0 && (
                <tfoot>
                  <tr className="table-secondary fw-bold">
                    {headerWithoutAuditFields().map((column, index) => {
                      // Buscar si esta columna tiene un valor de summary
                      const summaryItem = model.data.Summary.find(s => s.ColumnName === column.FieldName);
                      const alignment = getColumnAlignment(column.FieldName);
                      const summaryAlign = alignment === 'right' ? 'right' : 'center';
                      
                      return (
                        <td key={index} className="fw-bold" style={{ textAlign: summaryAlign }}>
                          {summaryItem ? summaryItem.SummValue.toLocaleString('en-US') : ''}
                        </td>
                      );
                    })}
                  </tr>
                </tfoot>
              )}
            </Table>
                </div>
            </div>

            <div className="d-flex justify-content-between align-items-center">
              {(model?.data?.Columns && model?.data?.Rows.length > 0) && (<div className="d-flex align-items-center gap-3">
                <p className="m-0 fw-bold">Total de registros:</p>
                <span 
                  className="badge d-flex align-items-center justify-content-center" 
                  style={{ 
                    fontSize: '0.875rem', 
                    height: '31px',
                    minWidth: '70px',
                    backgroundColor: '#ffffff', 
                    color: '#495057',
                    border: '1px solid #DFE2E6',
                    padding: '0.375rem 0.75rem',
                    borderRadius: '.25rem'
                  }}
                >
                  {recordCount.toLocaleString('en-US')}
                </span>
                
                <p className="m-0">Registros por página:</p>
                <div>
                  <select
                    className="form-select form-select-sm"
                    value={RecordsQuantity}
                    onChange={(e) => {
                      const selectedValue = Number(e.target.value);
                      console.log("📊 Selected value:", selectedValue, "Type:", typeof selectedValue);
                      setRecordsQuantity(selectedValue);
                      setCurrentPage(1);
                    }}
                  >
                    {allowedPageSizes.map((item, index) => {
                      return (
                        <option key={index} value={item.value}>
                          {item.text}
                        </option>
                      );
                    }
                    )}
                  </select>
                </div>
              </div>)}
              {(model?.data?.Columns && model?.data?.Rows.length > 0) && (<Pagination className="my-0">
                <Pagination.First disabled={loading} onClick={() => setCurrentPage(1)} />
                <Pagination.Prev onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage <= 1 || loading} />
                
                {/* Lógica de paginación dinámica - Muestra 5 páginas */}
                {(() => {
                  const pages = [];
                  let startPage, endPage;
                  
                  if (totalPages <= 5) {
                    // Si hay 5 páginas o menos, mostrar todas
                    startPage = 1;
                    endPage = totalPages;
                  } else {
                    // Si hay más de 5 páginas
                    if (currentPage <= 3) {
                      // Al inicio: mostrar 1, 2, 3, 4, 5
                      startPage = 1;
                      endPage = 5;
                    } else if (currentPage >= totalPages - 2) {
                      // Al final: mostrar las últimas 5
                      startPage = totalPages - 4;
                      endPage = totalPages;
                    } else {
                      // En el medio: mostrar 2 antes y 2 después de la actual
                      startPage = currentPage - 2;
                      endPage = currentPage + 2;
                    }
                  }
                  
                  // Mostrar ellipsis al inicio si es necesario
                  if (startPage > 1) {
                    pages.push(
                      <Pagination.Item 
                        key={1}
                        disabled={loading} 
                        active={false}
                        onClick={() => setCurrentPage(1)}
                      >
                        1
                      </Pagination.Item>
                    );
                    if (startPage > 2) {
                      pages.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
                    }
                  }
                  
                  // Mostrar las páginas del rango
                  for (let i = startPage; i <= endPage; i++) {
                    pages.push(
                      <Pagination.Item 
                        key={i}
                        disabled={loading} 
                        active={currentPage === i}
                        onClick={() => setCurrentPage(i)}
                      >
                        {i}
                      </Pagination.Item>
                    );
                  }
                  
                  // Mostrar ellipsis al final si es necesario
                  if (endPage < totalPages) {
                    if (endPage < totalPages - 1) {
                      pages.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
                    }
                    pages.push(
                      <Pagination.Item 
                        key={totalPages}
                        disabled={loading} 
                        active={false}
                        onClick={() => setCurrentPage(totalPages)}
                      >
                        {totalPages}
                      </Pagination.Item>
                    );
                  }
                  
                  return pages;
                })()}
                
                <Pagination.Next disabled={currentPage >= totalPages || loading} onClick={() => setCurrentPage(currentPage + 1)} />
                <Pagination.Last disabled={loading} onClick={() => setCurrentPage(totalPages)} />
              </Pagination>)}
            </div>
            {/* {console.log("Current Page", currentPage, "Total Pages", totalPages)} */}
          </Row>
        </Container>

        {/* Add by Victor: Agrega la maquetacion del formato en PDF */}
        <Container id="contentContainer" style={{ 
            position: 'absolute', 
            left: '-9999px', 
            top: 0,
            width: '100%' // Ancho fijo para el PDF
          }}>
          <div className="mb-4 text-center">
            <img src={logoSignos} alt="Signos Framework" width={400} />
            <h3 className="fw-bold">Signos Framework SRL</h3>
            <p>Ave. Rómulo Betancourt, Esq. Dr. Fernando A. Defilló, No. 1428 · Sector Bella Vista · Santo Domingo, República Dominicana.</p>
            <p>RNC: 1234567890</p>
            <p>Fecha: {moment().format("DD/MM/YYYY")}</p>
          </div>
          <Row className="mx-2">
            <h4 className="text-center fw-bold">{section.FormTitle}</h4>

            <Table hover size="xl" bordered className="border shadow-sm" >
              <thead className="table-secondary">
                <tr>
                  {headerWithoutAuditFields()
                    .map((item, index) => {
                      const alignment = getColumnAlignment(item.FieldName);
                      return (
                        <th key={index} className={`fw-bold`} style={{ textAlign: alignment === 'right' ? 'right' : 'center' }}>
                          {item.FieldTitle}
                        </th>
                      )
                    })}
                </tr>
              </thead>
              <tbody>
                {model?.data && model.data.Rows.map((item, index) => {
                  return (
                    <tr key={index}>
                      {headerWithoutAuditFields()
                        .map((column, index2) => {
                          const alignment = getColumnAlignment(column.FieldName);
                          
                          // Si es la columna Icon, renderizar el icono (solo visual para PDF)
                          if (column.FieldName === "Icon" && item[column.FieldName]) {
                            const cellValue = item[column.FieldName];
                            
                            // Intentar parsear si es un string JSON con array de iconos
                            let parsedIcons = null;
                            if (typeof cellValue === 'string' && (cellValue.trim().startsWith('[') || cellValue.trim().startsWith('{'))) {
                              try {
                                // Limpiar el JSON: eliminar comas antes de ] o }
                                let cleanedJson = cellValue
                                  .replace(/,(\s*[\]}])/g, '$1') // Eliminar comas antes de ] o }
                                  .replace(/\r\n/g, '') // Eliminar saltos de línea \r\n
                                  .replace(/\n/g, ''); // Eliminar saltos de línea \n
                                
                                parsedIcons = JSON.parse(cleanedJson);
                              } catch (e) {
                                // Si falla el parseo, continuar con el flujo normal
                              }
                            }
                            
                            // Si logramos parsear un array de iconos estructurados
                            if (Array.isArray(parsedIcons) && parsedIcons.length > 0 && parsedIcons[0].icon) {
                              return (
                                <td key={index2} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                  <div className="d-flex justify-content-center align-items-center gap-3">
                                    {parsedIcons.map((iconObj, iconIdx) => {
                                      const isDisabled = iconObj.Enabled === "false" || iconObj.Enabled === false;
                                      return (
                                        <i 
                                          key={iconIdx}
                                          className={iconObj.icon} 
                                          style={{ 
                                            fontSize: '1.2rem', 
                                            display: 'inline-block',
                                            color: isDisabled ? '#ccc' : '#000',
                                            opacity: isDisabled ? 0.5 : 1,
                                            margin: '0 10px'
                                          }}
                                          title={iconObj.Name || ''}
                                        ></i>
                                      );
                                    })}
                                  </div>
                                </td>
                              );
                            }
                            // Formato antiguo: Icono simple como string
                            else {
                              const cleanIconClass = cellValue
                                .replace(/\r\n/g, '')
                                .replace(/\n/g, '')
                                .replace(/\\/g, '')
                                .trim();
                              
                              return (
                                <td key={index2} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                  <i className={cleanIconClass} style={{ fontSize: '1.2rem', display: 'inline-block' }}></i>
                                </td>
                              );
                            }
                          }
                          
                          if (column.FieldType === "datetime" || column.FieldType === "date") {
                            return (
                              <td key={index2} style={{ textAlign: alignment }}>{moment(item[column.FieldName]).format("MM/DD/YYYY")}</td>
                            )
                          }

                          return (
                            <td key={index2} style={{ textAlign: alignment }}>
                              {(typeof item[column.FieldName] === 'boolean') ? 
                                (item[column.FieldName] ? 'Sí' : 'No') : 
                                item[column.FieldName]
                              }
                            </td>
                          )
                        })}
                    </tr>
                  )
                })}
              </tbody>
              {model?.data?.Summary && model.data.Summary.length > 0 && (
                <tfoot>
                  <tr className="table-secondary fw-bold">
                    {headerWithoutAuditFields().map((column, index) => {
                      // Buscar si esta columna tiene un valor de summary
                      const summaryItem = model.data.Summary.find(s => s.ColumnName === column.FieldName);
                      const alignment = getColumnAlignment(column.FieldName);
                      const summaryAlign = alignment === 'right' ? 'right' : 'center';
                      
                      return (
                        <td key={index} className="fw-bold" style={{ textAlign: summaryAlign }}>
                          {summaryItem ? summaryItem.SummValue.toLocaleString('en-US') : ''}
                        </td>
                      );
                    })}
                  </tr>
                </tfoot>
              )}
            </Table>
          </Row>
        </Container>
      </>
    );
  };

  //EVENTS


  // useEffect(() => {
  //   setOpen(false)
  //   setSelectedItem(null)
  //   setSelectedItemIndex(null)
  //   setActionMode(null)
  //   setGeneralError(null)
  //   setModel(initialModel);
  //   checkIfPinned();
  //   setIsSearching(true);
  //   setSearch("");
  //   setColumnFilters({});
  //   setShowTable(false); // Ocultar tabla al cambiar de reporte
  //   bindDataModelRemote();
  //   bindDataHeaderRemote();
  //   setCurrentPage(1);
  //   //bindDataRemote();

  //   return () => formik.resetForm();
  // }, [params.id]);

  // useEffect(() => {
  //   console.log("section updated", model)
  //   prepareFormikObject();
  // }, [section, fields]);
  // END EVENTS
  
  // REMOVIDO: bindDataRemote ya tiene RecordsQuantity en sus dependencias del useCallback
  // useEffect(() => {
  //   console.log("entro record quantity")
  //   bindDataRemote();
  // }, [RecordsQuantity])
  
  // Debug para ver el estado de section, fields y tableHeader
  useEffect(() => {
    console.log("🔍 Estado actual:");
    console.log("  - section:", section);
    console.log("  - fields:", fields);
    console.log("  - tableHeader:", tableHeader);
    console.log("  - model.data.Rows:", model?.data?.Rows);
  }, [section, fields, tableHeader, model]);

  useEffect(() => {
    const initializeScreen = async () => {
      console.log("🔄 Inicializando pantalla...");
      setShowTable(false);
      setSelectedItem(null);
      setSelectedItemIndex(null);
      setCurrentPage(1);
      
      // Verificar si la pantalla está en favoritos
      checkIfPinned();
      
      // Cargar headers y filtros
      await getTableHeaders();
    };
    
    initializeScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);
  
  // 2. Recargar datos cuando cambia la página o la cantidad de registros
  useEffect(() => {
    // Solo recargar si ya se inicializaron los filtros (filterValues tiene datos)
    if (Object.keys(filterValues).length > 0) {
      console.log("🔄 Recargando datos - Página:", currentPage, "Cantidad:", RecordsQuantity);
      getTableData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, RecordsQuantity]);
  
  // 3. Calcular páginas
  useEffect(() => {
    // Si se seleccionó "Todos" (RecordsQuantity = 0), solo hay 1 página
    if (RecordsQuantity === 0) {
      setTotalPages(1);
      console.log("Record Count", recordCount, "Records Quantity", RecordsQuantity);
      console.log("Pages calculated: 1 (Todos)");
    } else {
      const pages = RecordsQuantity > 0 ? Math.ceil(recordCount / RecordsQuantity) : 1;
      console.log("Record Count", recordCount, "Records Quantity", RecordsQuantity);
      console.log("Pages calculated:", pages);
      setTotalPages(pages);
    }
  }, [recordCount, RecordsQuantity]);
  
  // 4. Debug (puedes eliminarlo en producción)
  useEffect(() => {
    console.log("🔍 Estado actual:");
    console.log("  - section:", section);
    console.log("  - fields:", fields);
    console.log("  - tableHeader:", tableHeader);
    console.log("  - dynamicFilters:", dynamicFilters);
    console.log("  - filterValues:", filterValues);
    console.log("  - model.data.Rows:", model?.data?.Rows);
  }, [section, fields, tableHeader, model, dynamicFilters, filterValues]);
  
  // 5. Calcular la altura del header sticky para ajustar el top del thead
  useEffect(() => {
    const node = stickyHeaderRef.current;

    if (!node) {
      setStickyHeaderHeight(0);
      return;
    }

    const updateStickyHeight = () => {
      const height = node.offsetHeight || 0;
      setStickyHeaderHeight(height);
      console.log("📏 Altura del header sticky (ProcessSimpleV1):", height);
    };

    updateStickyHeight();

    const observer = typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(updateStickyHeight)
      : null;

    if (observer) {
      observer.observe(node);
    }

    window.addEventListener('resize', updateStickyHeight);

    return () => {
      if (observer) {
        observer.disconnect();
      }
      window.removeEventListener('resize', updateStickyHeight);
    };
  }, [isSearching, open, actionMode, loading, section, model?.data?.Rows?.length, dynamicFilters?.length, showTable]);
  
  return (
    <>
      {open ?
        <Modal
          show={open}
          onHide={() => toggleOpen(null)}
          backdrop="static"
          keyboard={false}
          dialogClassName="modal-fullwidth-custom"
          className="modalRight"
        >
          <Modal.Header style={{ backgroundColor: "#D7DEE5" }}>
            <Modal.Title className="fw-bold">Plazas Disponibles</Modal.Title>
            <CustomCloseButton onClose={() => toggleOpen(null)} />
          </Modal.Header>
            <Modal.Body>
            {/* Título de la sección */}
            <label className="me-2 mt-2 separatorTitle">Datos del Colaborador</label>
                          <br />
            <hr className="separatorLine" />
{/* Campos dinámicos del colaborador basados en el Model */}
            <Row className="mb-3">
              {fields
                .filter(field => field.Visible && field.FieldName !== 'Icon' && field.FieldName !== 'Ok')
                .map((field, index) => {
                  const value = selectedItem?.[field.FieldName] || '';
                  const isReadOnly = field.ReadOnly !== false;
                  
                  return (
                    <div key={index} className={field.cssClass || 'col-12 col-md-6'}>
                      <label className="me-2 mt-3">{field.FieldTitle}</label>
                      <br />
                      {field.HtmlType === 'textarea' ? (
                        <textarea
                          className="form-control"
                          value={value}
                          readOnly={isReadOnly}
                          disabled={isReadOnly || actionMode === "C"}
                          rows={5}
                        />
                      ) : field.HtmlType === 'date' ? (
                        <DateBox
                          className={`${isReadOnly || actionMode === "C" ? "form-read-only" : ""}`}
                          readOnly={isReadOnly || actionMode === "C"}
                          id={field.FieldName}
                          name={field.FieldName}
                          placeholder={field.PlaceHolder || "Seleccione la fecha"}
                          displayFormat="dd/MM/yyyy"
                          value={value ? moment(value).isValid() ? moment(value).toDate() : null : null}
                          onValueChanged={(e) => {
                            const formattedDate = e.value ? moment(e.value).format('YYYY-MM-DD') : '';
                            // Actualizar estado si aplica
                          }}
                        />
                      ) : field.HtmlType === 'checkbox' ? (
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={!!value}
                          readOnly={isReadOnly}
                          disabled={isReadOnly || actionMode === "C"}
                        />
                      ) : field.HtmlType === 'hidden' ? null : (
                        <TextBox
                          value={value}
                          readOnly={isReadOnly}
                          disabled={isReadOnly || actionMode === "C"}
                        />
                      )}
                    </div>
                  );
                })}
            </Row>

            {/* Tabla de habitaciones disponibles */}
            <Row>
              <Col md={12}>
              <label className="me-2 mt-3 separatorTitle">
                Plazas Disponibles: {detailItems.length > 0 ? detailItems.length : 0}
              </label>
              <br />
              <hr className="separatorLine" />
                <div style={{ 
                  maxHeight: 'calc(100vh - 520px)', 
                  minHeight: 'auto',
                  overflowY: 'auto',
                  overflowX: 'auto', 
                  position: 'relative',
                  border: '1px solid #dee2e6',
                  borderRadius: '0.25rem'
                }}>
                <Table hover bordered className="shadow-sm" size="sm" style={{ position: 'relative', marginBottom: 0 }}>
                  <thead className="table-secondary" style={{ 
                    position: 'sticky', 
                    top: 0, 
                    zIndex: 1,
                    backgroundColor: '#e9ecef',
                  }}>
                    <tr>
                      {
                        plazasHeaders.filter(header => header.Visible !== false)
                        .map((header, index) => (
                          <th 
                            key={index} 
                            className={header.Alignment === 'center' ? 'text-center' : ''}
                            style={{ textAlign: header.Alignment || 'left' }}
                          >
                            {header.FieldTitle}
                          </th>
                        ))
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {/* {detailItems.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center text-muted">
                          No hay plazas disponibles.
                        </td>
                      </tr>
                    ) : (
                      detailItems.map((item, index) => (
                        <tr key={item.Id}>
                          <td>{item.Codigo}</td>
                          <td>{item.Plaza}</td>
                          <td>{item.Categoria}</td>
                          <td>{item.Estado}</td>
                          <td>{item.Ocupante}</td>
                          <td className="text-center">{item.FechaSalida}</td>
                          <td>{item.MotivoSalida}</td>
                          <td>{item.ComentarioSalida}</td>
                        </tr>
                      ))
                    )} */}
                    {detailItems.length === 0 ? (
                      <tr>
                        <td colSpan={plazasHeaders.length > 0 ? plazasHeaders.filter(h => h.Visible !== false).length : 8} className="text-center text-muted">
                          No hay plazas disponibles.
                        </td>
                      </tr>
                    ) : (
                      detailItems.map((item, index) => (
                        <tr 
                          key={item.Id || index}
                          onClick={() => {
                            setSelectedPlaza(item);
                            setSelectedPlazaIndex(index);
                            console.log("🏠 Plaza seleccionada:", item);
                          }}
                          className={selectedPlazaIndex === index ? "active" : ""}
                          style={{ cursor: 'pointer' }}
                        >
                          {plazasHeaders.length > 0 ? (
                            plazasHeaders
                              .filter(header => header.Visible !== false)
                              .map((header, colIndex) => (
                                <td 
                                  key={colIndex}
                                  className={header.Alignment === 'center' ? 'text-center' : ''}
                                  style={{ textAlign: header.Alignment || 'left' }}
                                >
                                  {item[header.FieldName]}
                                </td>
                              ))
                          ) : (
                            // Si no hay headers, usa las columnas hardcodeadas como fallback
                            <>
                              <td>{item.Codigo}</td>
                              <td>{item.Plaza}</td>
                              <td>{item.Categoria}</td>
                              <td>{item.Estado}</td>
                              <td>{item.Ocupante}</td>
                              <td className="text-center">{item.FechaSalida}</td>
                              <td>{item.MotivoSalida}</td>
                              <td>{item.ComentarioSalida}</td>
                            </>
                          )}
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
                </div>
              </Col>
            </Row>

            <hr className="separatorLine" />
            <Row className="mb-3">
              <Col md={2}>
                <label className="me-2 mt-3 separatorTitle">
                  Fecha Asignación <span className="text-danger">*</span>
                </label>
                <DateBox
                  className={`${actionMode === "C" ? "form-read-only" : ""}`}
                  readOnly={actionMode === "C"}
                  id="fechaAsignacion"
                  name="fechaAsignacion"
                  placeholder="Seleccione la fecha"
                  displayFormat="dd/MM/yyyy"
                  value={fechaAsignacion ? moment(fechaAsignacion).isValid() ? moment(fechaAsignacion).toDate() : null : null}
                  onValueChanged={(e) => {
                    const formattedDate = e.value ? moment(e.value).format('YYYY-MM-DD') : '';
                    setFechaAsignacion(formattedDate);
                  }}
                />
                {validationErrors.fechaAsignacion && (
                  <div className="invalid text-sm">
                    {validationErrors.fechaAsignacion}
                  </div>
                )}
              </Col>
              <Col md={10}>
                <label className="me-2 mt-3 separatorTitle">
                  Motivo <span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={motivosOptions}
                  displayExpr="Descripcion"
                  valueExpr="Id"
                  value={selectedMotivo}
                  onValueChanged={(e) => setSelectedMotivo(e.value)}
                  placeholder={loadingMotivos ? "Cargando motivos..." : "Seleccione un motivo"}
                  searchEnabled={true}
                  disabled={actionMode === "C" || loadingMotivos}
                  showClearButton={true}
                />
                {validationErrors.selectedMotivo && (
                  <div className="invalid text-sm">
                    {validationErrors.selectedMotivo}
                  </div>
                )}
              </Col>
            </Row>

            <Row className="mb-3">
              
            </Row>


            <Row className="mt-4">
              <Col md={12}>
              <label className="me-2 mt-2 separatorTitle">Comentario de Asignación</label>
              {/* <textarea
                  ref={comentarioRef}
                  className="form-control"
                  rows={5}
                  placeholder="Ingrese un comentario sobre esta asignación (opcional)..."
                  value={comentarioAsignacion}
                  onChange={(e) => setComentarioAsignacion(e.target.value)}
                  disabled={actionMode === "C"}
                  maxLength={500}
                /> */}
                <div ref={comentarioRef}>
                  <FieldSelector
                    model={{
                      HtmlType: "textarea",
                      FieldName: "ComentarioAsignacion",
                      PlaceHolder: "Ingrese un comentario sobre esta asignación (opcional)...",
                      ReadOnly: actionMode === "C",
                      Required: false
                    }}
                    actionMode={actionMode}
                    value={comentarioAsignacion}
                    updateField={(fieldName, value) => {
                      setComentarioAsignacion(value);
                    }}
                    obj={{}}
                  />
                </div>
              </Col>
            </Row>

            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#D7DEE5" }}>
              <div className="d-flex gx-3 align-items-center justify-content-end">
                {Object.keys(validationErrors).length > 0 && (
                  <span className="invalid me-2">
                    Por favor, verificar los errores en el formulario
                  </span>
                )}
                
                {/* 
                <button className={`btn ${actionMode === "C" ? "btn-primary" : "btn-danger"} me-2`} type="button" onClick={() => toggleOpen(null)} style={{ width: "155px", height: "40px" }}>{actionMode === "C" ? "Cerrar" : "Cancelar"}</button> */}
                
                <button  
                  className='btn btn-cancel-hover me-2' 
                  type="button" onClick={() => toggleOpen(null)} 
                  style={{ width: "155px", height: "40px" }}>
                  <i className="fa-thin fa-arrow-u-turn-up-left me-2"></i>
                  {actionMode === "C" ? "Cerrar" : "Cancelar"}
                </button>
              {actionMode !== "C" && 
                <button 
                  className="btn btn-success" 
                  type="button" 
                  disabled={loading || !selectedPlaza || !selectedMotivo || !fechaAsignacion || detailItems.length === 0}
                  onClick={async () => {
                    // Limpiar errores previos
                    setValidationErrors({});
                    
                    // Objeto para acumular errores
                    const errors = {};
                    
                    // Validar que el motivo esté seleccionado (campo obligatorio)
                    if (!selectedMotivo) {
                      errors.selectedMotivo = "El motivo es obligatorio";
                    }
                    
                    // Validar que la fecha esté seleccionada (campo obligatorio)
                    if (!fechaAsignacion) {
                      errors.fechaAsignacion = "La fecha de asignación es obligatoria";
                    }
                    
                    // Si hay errores, establecerlos y no continuar
                    if (Object.keys(errors).length > 0) {
                      setValidationErrors(errors);
                      toast({
                        type: "error",
                        message: "Por favor, complete los campos obligatorios"
                      });
                      return;
                    }
                    
                    // Validar que haya una plaza seleccionada
                    if (!selectedPlaza) {
                      toast({
                        type: "warning",
                        message: "Debe seleccionar una plaza"
                      });
                      return;
                    }
                    
                    // Mostrar confirmación en ambos casos (con o sin comentario)
                    const mensajeConfirmacion = !comentarioAsignacion.trim() 
                      ? "¿Confirma que desea realizar la asignación sin indicar un comentario?"
                      : "¿Confirma que desea realizar esta Asignación?";
                    
                    confirmAlert({
                      closeOnClickOutside: false,
                      customUI: ({ onClose }) => {
                        return (
                          <CustomModal
                            type={!comentarioAsignacion.trim() ? "warning" : "info"}
                            title="¡Confirmar Acción!"
                            message={mensajeConfirmacion}
                            primaryButtonText="Confirmar"
                            secondaryButtonText="Cancelar"
                            onPrimaryClick={async () => {
                              // Enviar respuesta "Sí" al backend y hacer la asignación
                              await handleAsignarPlaza(mensajeConfirmacion, "Si");
                            }}
                            onSecondaryClick={async () => {
                              // Enviar respuesta "No" al backend (el usuario canceló)
                              await handleDialogResponse(mensajeConfirmacion, "No");
                              // Si no hay comentario, hacer scroll al campo
                              if (!comentarioAsignacion.trim() && comentarioRef.current) {
                                comentarioRef.current.scrollIntoView({ 
                                  behavior: 'smooth', 
                                  block: 'center' 
                                });
                                // Note: El focus no funciona directamente con DevExtreme TextArea
                                // pero el scrollIntoView sí posicionará el campo en la vista
                              }
                            }}
                            onClose={onClose}
                          />
                        );
                      }
                    });
                  }}
                  style={{ width: "155px", height: "40px", fontSize: "20px"}}
                  title={!selectedPlaza || detailItems.length === 0 ? "Debe seleccionar una plaza disponible" : ""}
                  
                  >
                    <i className="fa-thin fa-check me-2"></i>
                    {loading ? "Asignando..." : "Asignar"}
                </button>
              }
              </div>
            </Modal.Footer>
        </Modal> : null}
      

     

      {/* Contenedor Sticky que incluye Breadcrumb, Título y Filtros */}
      <div 
        ref={stickyHeaderRef}
        style={{
          position: 'sticky',
          top: '0px',
          backgroundColor: '#F2F2F2',
          zIndex: open ? 1 : 200,
        }}
      >
        {/* Breadcrumb y Título - Siempre visibles */}
        <Container>
          <Breadcrumbs pathTitle={section?.FormPath} />
          
          {/* Bloque del Título */}
          <div className="row mx-0">
            <div className={`col-12 d-flex align-items-center ${showTable && !isSearching ? 'justify-content-between' : ''}`}
               style={{ marginBottom: "12px" }}>
              <div className="d-flex align-items-center">
                <i className={(section.FormIcon || "fa-thin fa-clipboard-list") + " me-3 fa-2x"}></i>
                <div className="d-flex flex-column">
                  <h5 className="my-0">{section.FormTitle}</h5>
                </div>
              </div>
              
              {/* Botones de maximizar y ellipsis cuando los filtros están ocultos */}
              {showTable && !isSearching && (
                <div className="d-flex align-items-center gap-0">
                  <button
                    className="btn btn-sm rounded"
                    onClick={() => setIsSearching(!isSearching)}
                    style={{
                      border: '1px solid rgba(0, 0, 0, 0.15)',
                      transition: 'all 0.2s ease',
                      marginLeft: '10px',
                      fontSize: '16px',
                      backgroundColor: 'transparent',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(0, 123, 255, 0.08)';
                      e.currentTarget.style.transform = 'scale(1.05)';
                      e.currentTarget.querySelector('i').style.color = 'rgba(0, 123, 255, 0.9)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.querySelector('i').style.color = 'rgba(0, 0, 0, 0.6)';
                    }}
                    title="Mostrar filtros"
                  >
                    <i 
                      className="fa-sharp fa-thin fa-arrow-down-left-and-arrow-up-right-to-center"
                      style={{ 
                        color: 'rgba(0, 0, 0, 0.6)',
                        transition: 'color 0.2s ease'
                      }}
                    ></i>
                  </button>

                  <Dropdown>
                    <Dropdown.Toggle variant="button" id="dropdown-basic">
                      <i className="fa fa-ellipsis-v" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      {isPinned ? 
                        <Dropdown.Item onClick={() => { addFavorite() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                          <div style={{ width: '40px', display: 'inline-block' }}>
                            <i className="fa-thin fa-bookmark-slash" style={{ fontSize: '1.2rem' }}></i>
                          </div>
                          Remover de favoritos
                        </Dropdown.Item> : 
                        <Dropdown.Item onClick={() => { addFavorite() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                          <div style={{ width: '40px', display: 'inline-block' }}>
                            <i className="fa-thin fa-bookmark" style={{ fontSize: '1.2rem' }}></i>
                          </div>
                          Agregar a favoritos
                        </Dropdown.Item>
                      }
                      
                      {/* Solo mostrar opciones de exportar si la tabla tiene datos */}
                      {model?.data?.Rows && model.data.Rows.length > 0 && (
                        <>
                          <Dropdown.Divider />
                          {actionMode === null && 
                            <Dropdown.Item onClick={() => { exportToExcel() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                              <div style={{ width: '40px', display: 'inline-block' }}>
                                <i className="fa-thin fa-file-xls" style={{ fontSize: '1.2rem' }}></i>
                              </div>
                              Exportar a Excel
                            </Dropdown.Item>}
                          <Dropdown.Item onClick={() => { exportToPDF() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                              <div style={{ width: '40px', display: 'inline-block' }}>
                                <i className="fa-thin fa-file-pdf" style={{ fontSize: '1.2rem' }}></i>
                              </div>
                            Exportar a PDF
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => { handlePrint() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                              <div style={{ width: '40px', display: 'inline-block' }}>
                                <i className="fa-thin fa-print" style={{ fontSize: '1.2rem' }}></i>
                              </div>
                            Imprimir
                          </Dropdown.Item>
                        </>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )}
            </div>
          </div>
        </Container>

        {/* Panel de Filtros */}
        {isSearching && (
          <Container style={{ paddingBottom: '10px' }}>
          {/* BLOQUE DE LA CARD DE FILTROS */}
          <div className="row mx-0">
            <div className="col-12">
                  <Card className="mb-4" style={{ borderRadius: '7px' }}>
                    <Card.Body className="formBackground" style={{ borderRadius: '7px' }}>
                      <Row>
                        {loadingFilters && dynamicFilters.length === 0 ? (
                          <Col md={12} className="text-center text-muted py-4">
                            Cargando filtros...
                          </Col>
                        ) : (
                          <>
                            {dynamicFilters.map((filter, index) => (
                              <div key={filter.FieldName} className={filter.cssClass || 'col-12 col-md-6'}>
                                <label className="form-label small fw-bold">
                                  {filter.FieldTitle}
                                </label>
                                {filter.HtmlType === 'date' ? (
                                  <DateBox
                                    id={filter.FieldName}
                                    name={filter.FieldName}
                                    placeholder={filter.PlaceHolder || `Seleccione ${filter.FieldTitle}`}
                                    displayFormat="dd/MM/yyyy"
                                    value={filterValues[filter.FieldName] ? moment(filterValues[filter.FieldName]).isValid() ? moment(filterValues[filter.FieldName]).toDate() : null : null}
                                    onValueChanged={(e) => {
                                      const formattedDate = e.value ? moment(e.value).format('YYYY-MM-DD') : '';
                                      setFilterValues({
                                        ...filterValues,
                                        [filter.FieldName]: formattedDate
                                      })
                                    }}
                                  />
                                ) : filter.HtmlType === 'select' ? (
                                  <SelectBox
                                    value={filterValues[filter.FieldName] || ''}
                                    onValueChanged={(e) => setFilterValues({
                                      ...filterValues,
                                      [filter.FieldName]: e.value
                                    })}
                                    placeholder={`Buscar por ${filter.FieldTitle.toLowerCase()}...`}
                                    dataSource={filter.Options || []}
                                    displayExpr="name"
                                    valueExpr="value"
                                  />
                                ) : (
                                  <TextBox
                                    value={filterValues[filter.FieldName] || ''}
                                    onValueChanged={(e) => setFilterValues({
                                      ...filterValues,
                                      [filter.FieldName]: e.value
                                    })}
                                    placeholder={`Buscar por ${filter.FieldTitle.toLowerCase()}...`}
                                  />
                                )}
                              </div>
                            ))}
                          </>
                        )}
                      </Row>
                    </Card.Body>
                  </Card>
                  
                  <div className="d-flex justify-content-between mb-4">
                    <div>
                    <button
                      className="btn btn-outline-secondary me-2"
                      type="button"
                      title="Limpiar todos los filtros"
                      onClick={clearAllFilters}
                      disabled={loadingFilters}
                      style={{ width: '155px', height: '40px', fontSize: '14px' }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#364054';
                        e.currentTarget.style.borderColor = '#364054';
                        e.currentTarget.style.color = '#fff';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '';
                        e.currentTarget.style.borderColor = '';
                        e.currentTarget.style.color = '';
                      }}
                    >
                      <i className="fa-solid fa-filter-circle-xmark me-1"></i>
                      Limpiar
                    </button>
                    <button
                      className="btn btn-primary"
                      title="Consultar datos"
                      type="button"
                      disabled={loadingFilters}
                      onClick={async () => {
                        await getTableHeaders();
                        if (currentPage === 1) {
                          await getTableData();
                        } else {
                          setCurrentPage(1);
                        }
                        setShowTable(true);
                      }}
                      style={{ width: '155px', height: '40px', fontSize: '16px' }}
                    >
                      {loadingFilters ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Cargando...
                        </>
                      ) : (
                        <>
                          <Search className="me-1" />
                          Consultar
                        </>
                      )}
                    </button>
                    </div>
                    
                    {/* Botones de maximizar y ellipsis en la misma línea */}
                    {showTable && (
                      <div className="d-flex align-items-center gap-0">
                        {/* Botón de maximizar tabla */}
                        <button
                          className="btn btn-sm rounded me-2"
                          onClick={() => setIsSearching(!isSearching)}
                          style={{
                            border: '1px solid rgba(0, 0, 0, 0.15)',
                            transition: 'all 0.2s ease',
                            fontSize: '16px',
                            backgroundColor: 'transparent',
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(0, 123, 255, 0.08)';
                            e.currentTarget.querySelector('i').style.color = 'rgba(0, 123, 255, 0.9)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                            e.currentTarget.querySelector('i').style.color = 'rgba(0, 0, 0, 0.6)';
                          }}
                          title="Maximizar tabla (ocultar filtros)"
                        >
                          <i 
                            className="fa-sharp fa-thin fa-arrow-up-right-and-arrow-down-left-from-center"
                            style={{ 
                              color: 'rgba(0, 0, 0, 0.6)',
                              transition: 'color 0.2s ease'
                            }}
                          ></i>
                        </button>

                        <Dropdown>
                          <Dropdown.Toggle variant="button" id="dropdown-basic">
                            <i className="fa fa-ellipsis-v" />
                          </Dropdown.Toggle>
                          <Dropdown.Menu align="end">
                            {isPinned ? 
                              <Dropdown.Item onClick={() => { addFavorite() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                                <div style={{ width: '40px', display: 'inline-block' }}>
                                  <i className="fa-thin fa-bookmark-slash" style={{ fontSize: '1.2rem' }}></i>
                                </div>
                                Remover de favoritos
                              </Dropdown.Item> : 
                              <Dropdown.Item onClick={() => { addFavorite() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                                <div style={{ width: '40px', display: 'inline-block' }}>
                                  <i className="fa-thin fa-bookmark" style={{ fontSize: '1.2rem' }}></i>
                                </div>
                                Agregar a favoritos
                              </Dropdown.Item>
                            }
                            
                            {/* Solo mostrar opciones de exportar si la tabla tiene datos */}
                            {model?.data?.Rows && model.data.Rows.length > 0 && (
                              <>
                                <Dropdown.Divider />
                                {actionMode === null && 
                                  <Dropdown.Item onClick={() => { exportToExcel() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                                    <div style={{ width: '40px', display: 'inline-block' }}>
                                      <i className="fa-thin fa-file-xls" style={{ fontSize: '1.2rem' }}></i>
                                    </div>
                                    Exportar a Excel
                                  </Dropdown.Item>}
                                <Dropdown.Item onClick={() => { exportToPDF() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                                    <div style={{ width: '40px', display: 'inline-block' }}>
                                      <i className="fa-thin fa-file-pdf" style={{ fontSize: '1.2rem' }}></i>
                                    </div>
                                  Exportar a PDF
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => { handlePrint() }} style={{ fontWeight: 400, fontSize: '14px' }}>
                                    <div style={{ width: '40px', display: 'inline-block' }}>
                                      <i className="fa-thin fa-print" style={{ fontSize: '1.2rem' }}></i>
                                    </div>
                                  Imprimir
                                </Dropdown.Item>
                              </>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    )}
                  </div>
                </div>
              </div>
          </Container>
        )}
      </div>

      {/* Sección de la tabla de resultados */}
      <Container>
        <div className="row mx-0">
          <div className="col-12">
            {showTable && loadGRIDUI()}
          </div>
        </div>
      </Container>

      {/* Modal de error de la API */}
      <ErrorModal />
    </>
  );
}
